<template>
  <div>
    <div class="content">
      <!-- 自定义步骤导航 -->
      <div class="custom-steps-container">
        <div class="custom-steps">
          <div class="custom-step" :class="{ 'active': currentStep >= 0, 'completed': currentStep > 0 }">
            <div class="step-icon">
              <van-icon name="checked" size="24" v-if="currentStep > 0" />
              <span v-else>1</span>
            </div>
            <div class="step-title">车头信息</div>
          </div>
          <div class="step-line" :class="{ 'active': currentStep > 0 }"></div>
          <div class="custom-step" :class="{ 'active': currentStep >= 1 }">
            <div class="step-icon">
              <span>2</span>
            </div>
            <div class="step-title">车挂信息</div>
          </div>
        </div>
      </div>

      <!-- 车头信息表单 -->
      <div v-show="currentStep === 0 ">
        <van-form @submit="nextStep" ref="headForm" @failed="submitFailed">
          <div v-if="!chetouEditable" class="readonly-notice">
            <van-notice-bar
              left-icon="info-o"
              wrapable
              :scrollable="false"
              >
              如需修改信息，请先绑定后至我的页面点击车头信息管理进行修改。
            </van-notice-bar>
          </div>
          <van-cell-group inset class="form-card">
            <div class="usageSelector">
              <div class="section-title">
                <van-icon name="todo-list-o" size="18" color="#4080ff" />
                <span>车辆用途</span>

              </div>
              <ChoseVehicleUsage :vehicleUsage="vehicleUsage.typecode" @changeVehicleUsage="changeVehicleUsage" :disabled="!useEditable"/>
            </div>

            <div class="section-title" v-if="vehicleUsage.typecode!==''">
              <van-icon name="photo-o" size="18" color="#4080ff" />
              <span>行驶证照片</span>
            </div>
            <div class="upload-box" v-if="vehicleUsage.typecode!==''">
              <div class="xszzy">
                <h2 class="upload-title red-required">行驶证正页 <span class="image-show" @click="showImageDemo('zbfm', 1)">（示例图）</span></h2>
                <div class="upload-container">
                  <van-uploader  :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_zb_fm_image" :before-read="beforeRead" :after-read="uploadXszZbFm" :before-delete="deleteXszZbFm"></van-uploader>
                  <!--                <div v-else class="readonly-images">-->
                  <!--                  <van-image v-for="(img, index) in xsz_zb_fm_image" :key="index" :src="img.url" width="80" height="80"/>-->
                  <!--                </div>-->
                </div>
              </div>

              <!-- 仅当vehicleUsage.typecode为2时显示额外的行驶证照片 -->
              <template v-if="vehicleUsage.typecode === '2'">
              <h2 class="upload-title red-required">行驶证副页 <span class="image-show" @click="showImageDemo('fbzm', 1)">（示例图）</span></h2>
              <div class="upload-container">
                <van-uploader v-if="chetouEditable" :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_fb_zm_image" :before-read="beforeRead" :after-read="uploadXszFbZm" :before-delete="deleteXszFbZm"></van-uploader>
                <div v-else class="readonly-images">
                  <van-image v-for="(img, index) in xsz_fb_zm_image" :key="index" :src="img.url" width="80" height="80"/>
                </div>
              </div>

              <h2 class="upload-title red-required">行驶证副页反面 <span class="image-show" @click="showImageDemo('fbfm', 1)">（示例图）</span></h2>
              <div class="upload-container">
                <van-uploader v-if="chetouEditable" :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_fb_fm_image" :before-read="beforeRead" :after-read="uploadXszFbFm" :before-delete="deleteXszFbFm"></van-uploader>
                <div v-else class="readonly-images">
                  <van-image v-for="(img, index) in xsz_fb_fm_image" :key="index" :src="img.url" width="80" height="80"/>
                </div>
              </div>

              <h2 class="upload-title red-required">行驶证机动车照片 <span class="image-show" @click="showImageDemo('zbzm', 1)">（示例图）</span></h2>
              <div class="upload-container">
                <van-uploader v-if="chetouEditable" :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_zb_zm_image" :before-read="beforeRead" :after-read="uploadXszZbZm" :before-delete="deleteXszZbZm"></van-uploader>
                <div v-else class="readonly-images">
                  <van-image v-for="(img, index) in xsz_zb_zm_image" :key="index" :src="img.url" width="80" height="80"/>
                </div>
              </div>
              </template>
            </div>

            <div v-if="vehicleUsage.typecode!==''" class="section-title">
              <van-icon name="records" size="18" color="#4080ff" />
              <span>基本信息</span>
            </div>
            <div v-if="vehicleUsage.typecode!==''" class="info-box baseInfo">
              <van-field v-model="chetouhao" name="chetouhao" :readonly="!chetouEditable" required :value="chetouhao" :rules="[{ validator:validatorChetou, message: '请填写车头号' }] " placeholder="请输入"
                         class="input-style"
                         input-align="right"
                         @input="refreshDriver"
                         @blur="onChetouBlur"
              >
                <template #label>
                  <span class="field-label">车头号</span>
                </template>
              </van-field>

              <!-- 仅当vehicleUsage.typecode为2时显示车辆识别代号 -->
              <van-field v-if="vehicleUsage.typecode === '2' && cheShow" v-model="chejiahao" name="chejiahao" :readonly="!chetouEditable" :value="chejiahao" placeholder="请输入" input-align="right">
                <template #label>
                  <span class="field-label">车辆识别代号</span>
                </template>
              </van-field>

              <van-field v-model="sscd" name="sscd" :readonly="!chetouEditable" required :value="sscd" :rules="[{ validator:validatorSscd, message: '请填写所属车队' }]" placeholder="请输入" input-align="right" @input="refreshDriver">
                <template #label>
                  <span class="field-label">所属车队</span>
                </template>
              </van-field>

              <!-- 仅当vehicleUsage.typecode为2时显示额外的基本信息 -->
              <template v-if="vehicleUsage.typecode === '2'">
              <van-field v-model="ctzl" name="ctzl" :readonly="!chetouEditable" type="number" :value="ctzl" input-align="right" >
                <template #extra>
                  <div class="unit">KG</div>
                </template>
                <template #label>
                  <span class="field-label">车头质量(单车填写)</span>
                </template>
              </van-field>

              <van-field v-model="zhengbeizhiliang" name="zhengbeizhiliang" :readonly="!chetouEditable" required :rules="vehicleUsage.typecode==='2' ?[{required: true, validator: validate_zhengbeizhiliang}] :[]" :value="zhengbeizhiliang" type="number" input-align="right" @input="refreshDriver">
                <template #extra>
                  <div class="unit">KG</div>
                </template>
                <template #label>
                  <span class="field-label">整备质量</span>
                </template>
              </van-field>

              <van-field v-model="zongzhiliang" name="zongzhiliang" :readonly="!chetouEditable" type="number" :value="zongzhiliang" input-align="right">
                <template #extra>
                  <div class="unit">KG</div>
                </template>
                <template #label>
                  <span class="field-label">总质量(单车填写)</span>
                </template>
              </van-field>

              <van-field input-align="right" :readonly="!chetouEditable" v-model="xingshizhenghdzzl" name="xingshizhenghdzzl" type="number" :value="xingshizhenghdzzl" :rules="vehicleUsage.typecode==='2' ? [{ validator:validatorXingshizhenghdzzl, message: '请填写行驶证核定载质量' }] : []">
                <template #extra>
                  <div class="unit">吨</div>
                </template>
                <template #label>
                  <span class="field-label">行驶证核定载质量(单车填写)</span>
                </template>
              </van-field>

              <ChoseTime :timeVmodel="xszYxq" :timeName="xszYxq" :timeLabel="xszYxqLabel" @getYxq="getXszYxq" :timeValue="xingshizhengyxq" :disabled="!chetouEditable" class="no-arrow" @close="continueDriver(2)" />
              </template>
            </div>
          </van-cell-group>

          <van-cell-group inset class="form-card" v-show="vehicleUsage.typecode == '2'">
            <div class="section-title">
              <van-icon name="certificate" size="18" color="#4080ff" />
              <span>道路运输证信息</span>
            </div>
            <div class="upload-box">
              <div class="head_dlysz_upload">
                <h2 class="upload-title red-required">道路运输证正本正面图片 <span class="image-show" @click="showImageDemo('dlyszm')">（示例图）</span></h2>
                <div class="upload-container">
                  <van-uploader v-if="chetouEditable" :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="dlys_zm_image" :before-read="beforeRead" :after-read="uploadDlysZm" :before-delete="deleteDlysZm"></van-uploader>
                  <div v-else class="readonly-images">
                    <van-image v-for="(img, index) in dlys_zm_image" :key="index" :src="img.url" width="80" height="80"/>
                  </div>
                </div>

                <h2 class="upload-title red-required">道路运输证（待理证）正面图片 <span class="image-show" @click="showImageDemo('dlczm')">（示例图）</span></h2>
                <div class="upload-container">
                  <van-uploader v-if="chetouEditable" :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="dcl_zm_image" :before-read="beforeRead" :after-read="uploadDclZm" :before-delete="deleteDclZm"></van-uploader>
                  <div v-else class="readonly-images">
                    <van-image v-for="(img, index) in dcl_zm_image" :key="index" :src="img.url" width="80" height="80"/>
                  </div>
                </div>

                <h2 class="upload-title red-required">道路运输证（待理证）反面图片 <span class="image-show" @click="showImageDemo('dlcfm')">（示例图）</span></h2>
                <div class="upload-container">
                  <van-uploader v-if="chetouEditable" :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="dcl_fm_image" :before-read="beforeRead" :after-read="uploadDclFm" :before-delete="deleteDclFm"></van-uploader>
                  <div v-else class="readonly-images">
                    <van-image v-for="(img, index) in dcl_fm_image" :key="index" :src="img.url" width="80" height="80"/>
                  </div>
                </div>
              </div>

              <div class="info-box head_dlysz_baseInfo">
                <ChoseTime :timeVmodel="dlysYxq" :timeName="dlysYxq" :timeLabel="dlysYxqLabel" @getYxq="getDlysYxq" :timeValue="daoluyszyxq" :disabled="!chetouEditable" :timeRequire="false" class="no-arrow" @close="continueDriver(4)"/>
                <ChosePz :pzTitle="pzTitle" :isShowImportant="isShowImportant" @getChosePz="getDlysChosePz" :resultPz="pzArray" :disabled="!chetouEditable" />

                <van-field input-align="right" :readonly="!chetouEditable" v-model="beizhuHead" autosize name="beizhuHead" type="textarea" rows="3" maxlength="50" placeholder="请输入备注" :value="beizhuHead">
                  <template #label>
                    <span class="field-label">备注</span>
                  </template>
                </van-field>
              </div>
            </div>
          </van-cell-group>

          <div class="btn-container">
            <van-button round block type="primary" native-type="submit" :loading="loadingBtn" color="#4080ff" class="addHeadBtn">
              下一步
            </van-button>
          </div>
        </van-form>
      </div>

      <!-- 车挂信息表单 -->
      <div v-show="currentStep === 1">
        <!-- 上一步按钮放在表单外部 -->
        <div class="btn-container">
          <van-button plain round type="button" @click="prevStep" class="prev-btn">
            上一步
          </van-button>
        </div>

        <div v-if="!cheguaEditable" class="readonly-notice">
          <van-notice-bar
            left-icon="info-o"
            wrapable
            :scrollable="false"
          >
            如需修改信息，请先绑定后至我的页面点击车挂信息管理进行修改。

          </van-notice-bar>
        </div>
        <van-form @submit="submitAll" ref="trailerForm"  @failed="submitFailed">
          <van-cell-group inset class="form-card">
            <div class="cheguaUsage">
              <div class="section-title">
                <van-icon name="todo-list-o" size="18" color="#4080ff" />
                <span>车辆用途</span>
              </div>
              <ChoseVehicleUsage :vehicleUsage="vehicleUsage.typecode" @changeVehicleUsage="changeVehicleUsage" :disabled="currentStep===1"/>
              <p class="usage-tip" v-if="currentStep === 1">如需修改车辆用途，请<span class="back-link" @click="prevStep">返回上一步</span>进行修改</p>
            </div>


            <div class="section-title">
              <van-icon name="photo-o" size="18" color="#4080ff" />
              <span>行驶证照片</span>
            </div>
            <div class="upload-box chegua_xsz_upload">
              <div class="cheguaxszzy">
                <h2 class="upload-title red-required">行驶证正页 <span class="image-show" @click="showImageDemo('zbfm')">（示例图）</span></h2>
                <div class="upload-container">
                  <van-uploader  :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="trailer_xsz_zb_fm_image" :before-read="beforeRead" :after-read="uploadTrailerXszZbFm" :before-delete="deleteTrailerXszZbFm"></van-uploader>
                  <!--                <div v-else class="readonly-images">-->
                  <!--                  <van-image v-for="(img, index) in trailer_xsz_zb_fm_image" :key="index" :src="img.url" width="80" height="80"/>-->
                  <!--                </div>-->
                </div>
              </div>


              <!-- 仅当vehicleUsage.typecode为2时显示额外的行驶证照片 -->
              <template v-if="vehicleUsage.typecode === '2'">
              <h2 class="upload-title red-required">行驶证副页 <span class="image-show" @click="showImageDemo('fbzm')">（示例图）</span></h2>
              <div class="upload-container">
                <van-uploader v-if="cheguaEditable" :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="trailer_xsz_fb_zm_image" :before-read="beforeRead" :after-read="uploadTrailerXszFbZm" :before-delete="deleteTrailerXszFbZm"></van-uploader>
                <div v-else class="readonly-images">
                  <van-image v-for="(img, index) in trailer_xsz_fb_zm_image" :key="index" :src="img.url" width="80" height="80"/>
                </div>
              </div>

              <h2 class="upload-title red-required">行驶证副页反面 <span class="image-show" @click="showImageDemo('fbfm')">（示例图）</span></h2>
              <div class="upload-container">
                <van-uploader v-if="cheguaEditable" :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="trailer_xsz_fb_fm_image" :before-read="beforeRead" :after-read="uploadTrailerXszFbFm" :before-delete="deleteTrailerXszFbFm"></van-uploader>
                <div v-else class="readonly-images">
                  <van-image v-for="(img, index) in trailer_xsz_fb_fm_image" :key="index" :src="img.url" width="80" height="80"/>
                </div>
              </div>

              <h2 class="upload-title red-required">行驶证机动车照片 <span class="image-show" @click="showImageDemo('zbzm')">（示例图）</span></h2>
              <div class="upload-container">
                <van-uploader v-if="cheguaEditable" :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="trailer_xsz_zb_zm_image" :before-read="beforeRead" :after-read="uploadTrailerXszZbZm" :before-delete="deleteTrailerXszZbZm"></van-uploader>
                <div v-else class="readonly-images">
                  <van-image v-for="(img, index) in trailer_xsz_zb_zm_image" :key="index" :src="img.url" width="80" height="80"/>
                </div>
              </div>
              </template>
            </div>

            <div class="trailerBaseInfo">
              <div class="section-title">
                <van-icon name="records" size="18" color="#4080ff" />
                <span>基本信息</span>
              </div>
              <div class="info-box">
                <van-field input-align="right" v-model="cheguahao" name="cheguahao" :readonly="!cheguaEditable" required :value="cheguahao" :rules=" [{ validator:validatorChegua, message: '请填写车挂号' }]" placeholder="请输入" @input="refreshDriver" @blur="onCheguaBlur">
                  <template #label>
                    <span class="field-label">车挂号</span>
                  </template>
                </van-field>

                <!-- 仅当vehicleUsage.typecode为2时显示车辆识别代号 -->
                <van-field v-if="vehicleUsage.typecode === '2' && cheShow" v-model="trailer_chejiahao" name="trailer_chejiahao" :readonly="!cheguaEditable" :value="trailer_chejiahao" placeholder="请输入" input-align="right">
                  <template #label>
                    <span class="field-label">车辆识别代号</span>
                  </template>
                </van-field>

                <van-field v-model="trailer_sscd" name="trailer_sscd"
                           input-align="right" :readonly="!cheguaEditable"
                           required :value="trailer_sscd" :rules="  [{ validator:validatorTrailerSscd, message: '请填写所属车队' }]" placeholder="请输入" @input="refreshDriver">
                  <template #label>
                    <span class="field-label">所属车队</span>
                  </template>
                </van-field>

                <van-field name="sfjzx" label="是否集装箱" :readonly="!cheguaEditable" required :rules="[{ validator:validatorSfjzx, message: '请确认是否集装箱' }]" input-align="right" label-width="10rem">
                  <template #input>
                    <van-radio-group v-model="sfjzx" direction="horizontal" @change="refreshDriver" >
                      <van-radio name="Y">是</van-radio>
                      <van-radio name="N">否</van-radio>
                    </van-radio-group>
                  </template>
                </van-field>

                <!-- 货仓数量 - 现在在两种模式下都显示 -->
                <van-field
                    v-model="cssl"
                    name="cssl"
                    readonly
                    clickable
                    :is-link="cheguaEditable"
                    required
                    input-align="right"
                    :rules=" [{ validator: validatorCssl, message: '请选择隔舱数量' }] "
                    placeholder="请选择隔舱数量"
                    @click="showCsslPicker = true;destroyDriver()">
                  <template #label>
                    <span class="field-label">隔舱数量</span>
                  </template>
                </van-field>

                <!-- 货仓数量选择器弹出层 -->
                <van-popup v-model="showCsslPicker" position="bottom" round @close="continueDriverByCssl">
                  <van-picker
                      show-toolbar
                      title="选择隔舱数量"
                      :columns="csslColumns"
                      @confirm="onCsslConfirm"
                      @cancel="showCsslPicker = false"
                  />
                </van-popup>

                <!-- 仅当vehicleUsage.typecode为2时显示额外的基本信息 -->
                <template v-if="vehicleUsage.typecode === '2'">
                  <van-field v-model="trailer_zhengbeizhiliang" input-align="right" :readonly="!cheguaEditable" name="trailer_zhengbeizhiliang" required :rules="vehicleUsage.typecode==='2' ? [{required: true, validator: validate_zhengbeizhiliang}] : []" :value="trailer_zhengbeizhiliang" type="number">
                    <template #extra>
                      <div class="unit">KG</div>
                    </template>
                    <template #label>
                      <span class="field-label">整备质量</span>
                    </template>
                  </van-field>

                  <van-field v-model="trailer_xingshizhenghdzzl" name="trailer_xingshizhenghdzzl" :readonly="!cheguaEditable" input-align="right" required type="number" :value="trailer_xingshizhenghdzzl" :rules="vehicleUsage.typecode==='2' ? [{ required:true, validator:validate_hedingzaizhiliang, message: '请填写行驶证核定载质量' }] : []">
                    <template #extra>
                      <div class="unit">吨</div>
                    </template>
                    <template #label>
                      <span class="field-label">行驶证核定载质量</span>
                    </template>
                  </van-field>

                  <ChoseTime :timeVmodel="trailer_xszYxq" :timeName="trailer_xszYxq" :timeLabel="trailer_xszYxqLabel" @getYxq="getTrailerXszYxq" :timeValue="trailer_xingshizhengyxq" :disabled="!cheguaEditable" class="no-arrow" @close="continueDriver(8)" />
                </template>
              </div>
            </div>
          </van-cell-group>

          <van-cell-group inset class="form-card" v-show="vehicleUsage.typecode == '2'">
            <div class="section-title">
              <van-icon name="certificate" size="18" color="#4080ff" />
              <span>道路运输证信息</span>
            </div>
            <div class="upload-box">
              <div class="trailer_dlysz_upload">
                <h2 class="upload-title red-required">道路运输证正本正面图片 <span class="image-show" @click="showImageDemo('dlyszm')">（示例图）</span></h2>
                <div class="upload-container">
                  <van-uploader v-if="cheguaEditable" :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="trailer_dlys_zm_image" :before-read="beforeRead" :after-read="uploadTrailerDlysZm" :before-delete="deleteTrailerDlysZm"></van-uploader>
                  <div v-else class="readonly-images">
                    <van-image v-for="(img, index) in trailer_dlys_zm_image" :key="index" :src="img.url" width="80" height="80"/>
                  </div>
                </div>

                <h2 class="upload-title red-required">道路运输证（待理证）正面图片 <span class="image-show" @click="showImageDemo('dlczm')">（示例图）</span></h2>
                <div class="upload-container">
                  <van-uploader v-if="cheguaEditable" :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="trailer_dcl_zm_image" :before-read="beforeRead" :after-read="uploadTrailerDclZm" :before-delete="deleteTrailerDclZm"></van-uploader>
                  <div v-else class="readonly-images">
                    <van-image v-for="(img, index) in trailer_dcl_zm_image" :key="index" :src="img.url" width="80" height="80"/>
                  </div>
                </div>

                <h2 class="upload-title red-required">道路运输证（待理证）反面图片 <span class="image-show" @click="showImageDemo('dlcfm')">（示例图）</span></h2>
                <div class="upload-container">
                  <van-uploader v-if="cheguaEditable" :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="trailer_dcl_fm_image" :before-read="beforeRead" :after-read="uploadTrailerDclFm" :before-delete="deleteTrailerDclFm"></van-uploader>
                  <div v-else class="readonly-images">
                    <van-image v-for="(img, index) in trailer_dcl_fm_image" :key="index" :src="img.url" width="80" height="80"/>
                  </div>
                </div>
              </div>
              <div class="info-box trailer_dlysz_baseInfo">
                <ChoseTime :timeVmodel="trailer_dlysYxq" :timeName="trailer_dlysYxq" :timeLabel="trailer_dlysYxqLabel" @getYxq="getTrailerDlysYxq" :timeValue="trailer_daoluyszyxq" :timeRequire="false" :disabled="!cheguaEditable" class="no-arrow" @close="continueDriver(10)"/>
                <ChosePz :pzTitle="trailer_pzTitle" :isShowImportant="trailer_isShowImportant" @getChosePz="getTrailerDlysChosePz" :resultPz="trailer_pzArray" :disabled="!cheguaEditable" />
              </div>
            </div>

            <div class="section-title">
              <van-icon name="column" size="18" color="#4080ff" />
              <span>罐体信息</span>
            </div>
            <div class="upload-box">
              <div class="guanjian_upload">
                <h2 class="upload-title">罐检图片（请上传含车挂号、罐容、介质、有效期页面的图片）</h2>
                <div class="upload-container">
                  <van-uploader v-if="cheguaEditable" :max-size="10 * 1024 * 1024" @oversize="onOversize" v-model="guanjianbgimage" :before-read="beforeRead" :after-read="uploadGtImage" :before-delete="deleteGtImage"></van-uploader>
                  <div v-else class="readonly-images">
                    <van-image v-for="(img, index) in guanjianbgimage" :key="index" :src="img.url" width="80" height="80"/>
                  </div>
                </div>
              </div>

              <div class="info-box guanjian_baseInfo">
                <van-field v-model="guantitiji" input-align="right" :readonly="!cheguaEditable" name="guantitiji" required :value="guantitiji" type="number" :rules="vehicleUsage.typecode === '2' ? [{ required:true, validator:validate_guantitiji, message: '请填写罐体体积' }] : []">
                  <template #extra>
                    <div class="unit">立方</div>
                  </template>
                  <template #label>
                    <span class="field-label">罐体体积</span>
                  </template>
                </van-field>

                <ChoseTime :timeVmodel="guanjianyxq" :timeName="guanjianyxq" :timeLabel="guanjianyxqLabel" @getYxq="getGuanjianyxq" :timeValue="guanjianyxq" :timeRequire="false" :disabled="!cheguaEditable" class="no-arrow" @close="continueDriver(12)" />
                <ChosePz :pzTitle="gtPzTitle" :isShowImportant="false" @getChosePz="getGtChosePz" :resultPz="gtPzArray" :disabled="!cheguaEditable" />
              </div>
            </div>
          </van-cell-group>

          <div class="guanticaizhiInfo">
            <van-cell-group inset class="form-card">
              <!-- 添加罐体材质选择器（与 addChegua.vue 保持一致，不受 vehicleUsage.typecode 控制） -->
              <div class="section-title">
                <van-icon name="shopping-cart-o" size="18" color="#4080ff" />
                <span>罐体材质</span>
              </div>
              <ChoseGtMaterial :gtMaterial="guanticaizhi" @changeGtMaterial="changeGtMaterial" :disabled="!cheguaEditable" @close="continueDriverByGtcz"/>

              <!-- 仅当vehicleUsage.typecode为2时显示舱室信息 -->
              <template v-if="vehicleUsage.typecode === '2'">
                <div class="section-title">
                  <van-icon name="column" size="18" color="#4080ff" />
                  <span>舱室信息</span>
                </div>
                <cabin-item :cabinValue="cabinValue" :cangshilifang1="cangshilifang1" :cangshilifang2="cangshilifang2" :cangshilifang3="cangshilifang3" @setCabin="setCabin" @getCsValue1="getCsValue1" @getCsValue2="getCsValue2" @getCsValue3="getCsValue3" :disabled="!cheguaEditable" @close="continueDriver(13)"></cabin-item>
              </template>

              <van-field v-model="beizhu" autosize input-align="right" :readonly="!cheguaEditable" name="beizhu" type="textarea" rows="3" maxlength="50" placeholder="请输入备注" :value="beizhu">
                <template #label>
                  <span class="field-label">备注</span>
                </template>
              </van-field>
            </van-cell-group>
          </div>

          <div class="btn-container">
            <van-button round type="primary" native-type="submit" :loading="loadingBtn" color="#4080ff" class="submit-btn" style="width: 100%;">
              提交
            </van-button>
          </div>
        </van-form>
      </div>
    </div>

    <!-- 添加回到顶部的悬浮按钮 -->
    <div class="back-to-top" v-show="showBackToTop" @click="scrollToTop">
      <van-icon name="arrow-up" size="20" />
    </div>

    <Tabbar></Tabbar>
  </div>
</template>

<script>
import api from "@/fetch/api"
import { Toast, Dialog, ImagePreview } from 'vant';
import ChoseTime from "../Public/choseTime.vue"
import ChosePz from "../Public/chosePz.vue"
import Compressor from 'compressorjs';
import CabinItem from '../Vehicle/cabinItem.vue'
import Tabbar from '../Public/tabbarTpl.vue'
import ChoseGtMaterial from '../Vehicle/choseGtMaterial.vue'
import ChoseVehicleUsage from '../Public/choseVehicleUsage.vue';
import store from '@/store';

export default {
  components: {
    ChoseTime,
    ChosePz,
    Tabbar,
    CabinItem,
    ChoseGtMaterial,
    ChoseVehicleUsage
  },
  data() {
    return {
      currentStep: 0,
      useEditable:true,
      loadingBtn: false,
      cheShow: false,
      isChetouExist: false, // 车头是否存在（上传）
      isCheguaExist: false, // 车挂是否存在（上传）
      chetouId: null, // 车头ID
      cheguaId: null, // 车挂ID
      chetouBpmStatus: 1, // 车头bpmStatus
      cheguaBpmStatus: 1, // 车挂bpmStatus
      originalChetouData: null, // 原始车头数据（用于比对）
      originalCheguaData: null, // 原始车挂数据（用于比对）
      chetouDataChanged: false, // 车头数据是否有变化
      cheguaDataChanged: false, // 车挂数据是否有变化
      refreshCheguaData: true, // 是否需要刷新车挂数据
      originalChetouDaoluyszjyfw: "", // 原始车头道路运输证经营范围
      originalCheguaDaoluyszjyfw: "", // 原始车挂道路运输证经营范围
      originalCheguaGuanjianjyfw: "", // 原始车挂罐检经营范围
      chetouDaoluyszjyfwChanged: false, // 车头道路运输证经营范围是否变化
      cheguaDaoluyszjyfwChanged: false, // 车挂道路运输证经营范围是否变化
      cheguaGuanjianjyfwChanged: false, // 车挂罐检经营范围是否变化
      isNewChetou: false, // 是否为新建车头
      isNewChegua: false, // 是否为新建车挂

      // 添加显示回到顶部按钮的状态
      showBackToTop: false,

      // 添加车头和车挂是否可编辑的状态
      chetouEditable: true,  // 车头是否可编辑
      cheguaEditable: true,  // 车挂是否可编辑

      // 车头信息表单数据
      vehicleUsage: { typecode: '' }, // 默认为蒸洗+作业

      // 车头行驶证图片
      xsz_zb_zm_image: [],
      xsz_zb_fm_image: [],
      xsz_fb_zm_image: [],
      xsz_fb_fm_image: [],
      xsz_zb_zm_url: "",
      xsz_zb_fm_url: "",
      xsz_fb_zm_url: "",
      xsz_fb_fm_url: "",

      // 车头基本信息
      chetouhao: "", // 车头号
      sscd: "", // 所属车队
      chejiahao: "", // 车辆识别代号
      ctzl: 0, // 车头质量
      zhengbeizhiliang: 0, // 整备质量
      zongzhiliang: 0, // 总质量
      xingshizhenghdzzl: 0, // 行驶证核定载质量
      xingshizhengyxq: "", // 行驶证有效期
      xszYxq: "xingshizhengyxq",
      xszYxqLabel: "行驶证有效期",

      // 车头道路运输证信息
      dlys_zm_image: [],
      dcl_zm_image: [],
      dcl_fm_image: [],
      dlys_zm_url: "",
      dcl_zm_url: "",
      dcl_fm_url: "",
      daoluyszhao: "", // 道路运输证号
      daoluyszjyfw: "", // 道路运输证经营范围
      daoluyszyxq: "", // 道路运输证有效期
      dlysYxq: "daoluyszyxq",
      dlysYxqLabel: "道路运输证有效期",
      pzTitle: "道路运输证经营范围",
      isShowImportant: true,
      selectedData: [],
      pzArray: [],
      beizhuHead: "",

      // 车挂信息表单数据
      // 车挂行驶证图片
      trailer_xsz_zb_zm_image: [],
      trailer_xsz_zb_fm_image: [],
      trailer_xsz_fb_zm_image: [],
      trailer_xsz_fb_fm_image: [],
      trailer_xsz_zb_zm_url: "",
      trailer_xsz_zb_fm_url: "",
      trailer_xsz_fb_zm_url: "",
      trailer_xsz_fb_fm_url: "",

      // 车挂基本信息
      cheguahao: "", // 车挂号
      trailer_chejiahao: "", // 车辆识别代号
      trailer_sscd: "", // 所属车队
      sfjzx: "", // 是否集装箱
      trailer_zhengbeizhiliang: 0, // 整备质量
      trailer_xingshizhenghdzzl: 0, // 行驶证核定载质量
      trailer_xingshizhengyxq: "", // 行驶证有效期
      trailer_xszYxq: "trailer_xingshizhengyxq",
      trailer_xszYxqLabel: "行驶证有效期",
      cssl: "", // 货仓数量
      showCsslPicker: false, // 控制货仓数量选择器的显示
      csslColumns: Array.from({length: 12}, (_, i) => (i + 1).toString()), // 1-12的选项

      // 车挂道路运输证信息
      trailer_dlys_zm_image: [],
      trailer_dcl_zm_image: [],
      trailer_dcl_fm_image: [],
      trailer_dlys_zm_url: "",
      trailer_dcl_zm_url: "",
      trailer_dcl_fm_url: "",
      trailer_daoluyszhao: "", // 道路运输证号
      trailer_daoluyszjyfw: "", // 道路运输证经营范围
      trailer_daoluyszyxq: "", // 道路运输证有效期
      trailer_dlysYxq: "trailer_daoluyszyxq",
      trailer_dlysYxqLabel: "道路运输证有效期",
      trailer_pzTitle: "道路运输证经营范围",
      trailer_isShowImportant: true,
      trailer_selectedData: [],
      trailer_pzArray: [],

      // 罐体信息
      guantitiji: 0, // 罐体体积
      guanticaizhi: "", // 罐体材质
      guanjianyxq: "", // 罐检有效期
      guanjianyxq_title: "guanjianyxq",
      guanjianyxqLabel: "罐检有效期",
      guanjianjyfw: "", // 罐检经营范围
      guanjianbgurl: "", // 罐检报告URL
      guanjianbgurlArr: [], // 罐检报告URL数组
      guanjianbgImageArr: [], // 罐检报告图片数组
      guanjianbgimage: [], // 罐检报告图片
      gtPzTitle: "罐检经营范围",
      gtSelectedData: [],
      gtPzArray: [],

      

      // 舱室信息
      cabinValue: "单舱",
      cangshilifang1: 0,
      cangshilifang2: 0,
      cangshilifang3: 0,

      // 备注
      beizhu: "",

      // 时间选择器配置
      timeRequire: true,

      // driver动态步骤
      steps: [],
      // 车头行驶证引出的信息是否填充完毕
      hasFilled: false
    };
  },
  created() {
    document.title = "新增车辆信息";

    // 不再自动初始化车挂的所属车队，改为在需要时才设置
    // this.trailer_sscd = this.sscd;

    // 初始化是否集装箱为"否"
    // this.sfjzx = "N";

    // 初始化引导步骤
    this.steps.push({
      element: '.usageSelector',
      popover: {
        title: '请选择作业用途',
        // description: '描述文本',
        showButtons: ['next'],
        onNextClick: () => {
          if (this.vehicleUsage.typecode) {
            this.$driverObj.moveNext();
          } else {
            Toast.fail('请选择作业用途');
          }
        }
      },
    })
    this.$driverObj.setSteps(this.steps);
  },
  mounted() {
    // 添加滚动事件监听
    window.addEventListener('scroll', this.handleScroll);
    // 开始引导
    store.state.isFirstTime && this.$driverObj.drive();
  },
  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener('scroll', this.handleScroll);
    this.destroyDriver()
  },
  methods: {
    continueDriverByCssl() {
      if (this.vehicleUsage.typecode === '1') {
        this.continueDriver(6)
      } else if (this.vehicleUsage.typecode === '2') {
        this.continueDriver(8)
      }
    },
    // 罐体材质的续写
    continueDriverByGtcz() {
      if (this.vehicleUsage.typecode === '1') {
        this.continueDriver(7)
      } else if (this.vehicleUsage.typecode === '2') {
        this.continueDriver(13)
      }
    },
    // 整备质量校验
    validate_zhengbeizhiliang(val, rule) {
      rule.message = '请填写正确的整备质量';
      return !(parseFloat(val) <= 0);
    },
    // 行驶证核定载质量校验
    validate_hedingzaizhiliang(val, rule) {
      rule.message = '请填写正确的核定载质量';
      return !(parseFloat(val) <= 0);
    },
    validate_guantitiji(val, rule) {
      rule.message = '请填写正确的罐体体积';
      return !(parseFloat(val) <= 0);
    },
    // 刷新引导
    refreshDriver() {
      store.state.isFirstTime && this.$driverObj.refresh();
    },
    // 销毁引导
    destroyDriver() {
      store.state.isFirstTime && this.$driverObj.destroy();
    },
    // 继续引导
    continueDriver(stepIndex) {
      store.state.isFirstTime && this.$driverObj.drive(stepIndex);
    },

    // 仅蒸洗分支
    getPathA() {
      return [
        // 校验行驶证正页
        {
          element: '.xszzy',
          popover: {
            title: '上传资料',
            description: '请上传行驶证正页照片',
            showButtons: ['previous', 'next'],
            onNextClick: () => {
              this.xsz_zb_fm_url && this.hasFilled && this.$driverObj.moveNext();
            },
            onPrevClick: () => {
              this.steps[0].popover.showButtons = ['next']
              this.$driverObj.movePrevious();
            }
          }
        },{
          element: '.baseInfo',
          popover: {
            title: '填写信息',
            description: '请确认信息是否正确',
            onNextClick: () => {
              this.$refs.headForm.validate(['chetouhao', 'sscd']).then(() => {
                this.$driverObj.moveNext();
                window.scrollTo({
                  top: document.body.scrollHeight,
                  behavior: 'smooth'
                });
              }).catch(() => {
                this.$driverObj.refresh();
              })
            },
          }
        },{
          element: '.addHeadBtn',
          popover: {
            title: '点击按钮',
            description: '提交车头信息',
            showButtons: ['previous']
          }
        },{
          element: '.cheguaUsage',
          popover: {
            title: '确认车辆用途是否需要变更',
            onPrevClick: () => {
              this.steps[0].popover.showButtons = ['next']
              this.xsz_zb_fm_url && (this.steps[1].popover.showButtons = ['next'])
              this.prevStep()
            }
          }
        },{
          element: '.cheguaxszzy',
          popover: {
            title: '上传资料',
            description: '请上传车挂行驶证正页照片',
            onNextClick: () => {
              this.trailer_xsz_zb_fm_url && this.$driverObj.moveNext();
            }
          }
        },{
          element: '.trailerBaseInfo',
          popover: {
            title: '填写信息',
            description: '请确认基础信息是否正确',
            onNextClick: () => {
              this.$refs.trailerForm.validate(['cheguahao', 'trailer_sscd', 'sfjzx', 'cssl']).then(() => {
                this.$driverObj.moveNext();
                window.scrollTo({
                  top: document.body.scrollHeight,
                  behavior: 'smooth'
                });
              }).catch(() => {
                this.$driverObj.refresh();
                window.scrollTo({
                  top: document.body.scrollHeight,
                  behavior: 'smooth'
                });


              })
            }
          }
        },{
          element: '.guanticaizhiInfo',
          popover: {
            title: '填写信息',
            description: '请确认罐体信息是否正确',
            onNextClick: () => {
              this.$refs.trailerForm.validate(['shopping-cart-o']).then(() => {
                // 罐体材质验证 - 所有模式下都需要
                if (!this.guanticaizhi) {
                  Toast.fail('请选择罐体材质');
                  return
                }
                this.$driverObj.moveNext();
              }).catch(() => {
                this.$driverObj.refresh();
              })
            }
          }
        },{
          // 提交全部
          element: '.submit-btn',
          popover: {
            title: '点击按钮',
            description: '提交所有的信息, 完成绑定',
            showButtons: ['previous']
          }
        }
      ]
    },
    // 蒸洗+装卸货分支
    getPathB() {
      return [
        // 1
        {
          element: '.upload-box',
          popover: {
            title: '上传资料',
            description: '请上传对应的证件照片',
            onNextClick: () => {
              this.xsz_zb_fm_url && this.xsz_fb_zm_url && this.xsz_fb_fm_url && this.xsz_zb_zm_url && this.$driverObj.moveNext();
            },
            onPrevClick: () => {
              this.steps[0].popover.showButtons = ['next']
              this.$driverObj.movePrevious();
            }
          }
        },{
          // 2
          element: '.baseInfo',
          popover: {
            title: '填写信息',
            description: '请确认基础信息是否正确',
            onNextClick: () => {
              this.$refs.headForm.validate(['chetouhao', 'sscd', 'ctzl', 'zhengbeizhiliang', 'zongzhiliang', 'xingshizhenghdzzl', 'xingshizhengyxq']).then(() => {
                this.$driverObj.moveNext();
              }).catch(() => {
                this.$driverObj.refresh();
              })
            }
          }
        },{
          // 3
          element: '.head_dlysz_upload',
          popover: {
            title: '上传资料',
            description: '请上传对应的证件照片',
            onNextClick: () => {
              this.dlys_zm_url
              && this.dcl_zm_url
              && this.dcl_fm_url
              &&
              this.$driverObj.moveNext();
            }
          }
        },{
          // 4
          element: '.head_dlysz_baseInfo',
          popover: {
            title: '填写信息',
            description: '请确认道路运输基础信息是否正确',
            onNextClick: () => {
              this.$refs.headForm.validate(['daoluyszyxq']).then(() => {
                if (this.selectedData.length === 0) {
                  Toast.fail('请选择道路运输证经营范围');
                  return false;
                }
                this.$driverObj.moveNext();
              }).catch(() => {
                this.$driverObj.refresh();
              })
            }
          }
        },{
          // 5 引导点击保存按钮
          element: '.addHeadBtn',
          popover: {
            title: '点击按钮',
            description: '提交车头信息',
            showButtons: ['previous']
          }
        },{
          // 6 确认是否需要更换车辆用途
          element: '.cheguaUsage',
          popover: {
            title: '确认车辆用途是否需要变更',
            onPrevClick: () => {
              this.steps[0].popover.showButtons = ['next']
              this.prevStep()
            }
          }
        },{
          // 7. 车挂表单-行驶证相关上传
          element: '.chegua_xsz_upload',
          popover: {
            title: '上传资料',
            description: '请上传车挂行驶证对应的证件照片',
            onNextClick: () => {
              this.trailer_xsz_zb_fm_url
              && this.trailer_xsz_fb_zm_url
              && this.trailer_xsz_fb_fm_url
              && this.trailer_xsz_zb_zm_url
              &&
              this.$driverObj.moveNext();
            }
          }
        },{
          // 8. 车挂表单-行驶证基础信息
          element: '.trailerBaseInfo',
          popover: {
            title: '填写信息',
            description: '请确认基础信息是否正确',
            onNextClick: () => {
              this.$refs.trailerForm.validate(['cheguahao', 'trailer_sscd', 'sfjzx', 'cssl', 'trailer_zhengbeizhiliang', 'trailer_xingshizhenghdzzl', 'trailer_xingshizhengyxq']).then(() => {
                if (new Date(this.trailer_xingshizhengyxq) < new Date()) {
                  Toast.fail('车挂行驶证有效期不能小于当前日期');
                  return false;
                }
                this.$driverObj.moveNext();
              }).catch(() => {
                this.$driverObj.refresh();
              })
            }
          }
        },{
          // 9. 道路运输证证件
          element: '.trailer_dlysz_upload',
          popover: {
            title: '上传资料',
            description: '请上传对应道路运输证的证件照片',
            onNextClick: () => {
              this.trailer_dlys_zm_url
              && this.trailer_dcl_zm_url
              && this.trailer_dcl_fm_url
              &&
              this.$driverObj.moveNext();
            }
          }
        },{
          // 10. 道路运输证基本信息
          element: '.trailer_dlysz_baseInfo',
          popover: {
            title: '填写信息',
            description: '请确认道路运输证基础信息是否正确',
            onNextClick: () => {
              this.$refs.trailerForm.validate(['trailer_daoluyszyxq']).then(() => {
                if (this.trailer_selectedData.length === 0) {
                  Toast.fail('请选择车挂道路运输证经营范围');
                  return false;
                }
                this.$driverObj.moveNext();
              })
            }
          },
        },{
          // 11.罐检图片
          element: '.guanjian_upload',
          popover: {
            title: '上传资料',
            description: '请上传含车挂号、罐容、介质、有效期页面的图片',
            onNextClick: () => {
              if (this.guanjianbgurlArr.length === 0) {
                Toast.fail('请上传罐检图片');
                return;
              }
              this.$driverObj.moveNext();
            }
          }
        },{
          // 12.罐检基础信息
          element: '.guanjian_baseInfo',
          popover: {
            title: '填写信息',
            description: '请确认罐检信息是否正确',
            onNextClick: () => {
              this.$refs.trailerForm.validate(['guantitiji']).then(() => {
                if (!this.guanjianyxq) {
                  Toast.fail('请选择罐检有效期');
                  return;
                }

                // 验证罐检有效期
                const guanjianyxqDate = new Date(this.guanjianyxq);
                if (guanjianyxqDate < new Date()) {
                  Toast.fail('罐检有效期不能小于当前日期');
                  return;
                }

                if (this.gtSelectedData.length === 0) {
                  Toast.fail('请选择罐检经营范围');
                  return;
                }
                this.$driverObj.moveNext();
              })
            }
          }
        },{
          // 13. 罐体材质基础信息
          element: '.guanticaizhiInfo',
          popover: {
            title: '填写信息',
            description: '请填写罐体材质的相关信息',
            onNextClick: () => {
              // 罐体材质验证 - 所有模式下都需要
              if (!this.guanticaizhi) {
                Toast.fail('请选择罐体材质');
                return
              }

              // 验证货仓数量 - 现在两种模式都验证
              if (!this.cabinValue) {
                Toast.fail('请选择舱室信息');
                return
              }
              if (this.cabinValue === '双舱' || this.cabinValue === '三舱') {
                this.$refs.trailerForm.validate(['cs1', 'cs2']).then(() => {
                  this.$driverObj.moveNext();
                })
              } else if (this.cabinValue === '单舱') {
                this.$driverObj.moveNext();
              }
            }
          }
        },{
          // 14. 提交全部
          element: '.submit-btn',
          popover: {
            title: '点击按钮',
            description: '提交所有的信息, 完成绑定',
            showButtons: ['previous']
          }
        }
      ]
    },
    // 关闭加载提示
    closeLoadingToast() {
      Toast.clear();
    },
    
    // 滚动事件处理函数
    handleScroll() {
      // 当页面滚动超过300px时显示回到顶部按钮
      this.showBackToTop = window.pageYOffset > 300;
    },
    // 滚动到顶部函数
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },

    // 通用方法
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }
      return new Promise((resolve) => {
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })
      });
    },
    onOversize() {
      Toast('文件大小不能超过 10Mb');
    },
    showImageDemo(type, stepIndex) {
      const that = this
      this.destroyDriver()
      let images = [];
      switch (type) {
        case 'zbzm':
          images = [require('@/assets/images/ctsl.png')];
          break;
        case 'zbfm':
          images = [require('@/assets/images/zbfm.png')];
          break;
        case 'fbzm':
          images = [require('@/assets/images/fbzm.png')];
          break;
        case 'fbfm':
          images = [require('@/assets/images/fbfm.png')];
          break;
        case 'dlyszm':
          images = [require('@/assets/images/ctdlyszm.png')];
          break;
        case 'dlczm':
          images = [require('@/assets/images/ctdlczm.jpg')];
          break;
        case 'dlcfm':
          images = [require('@/assets/images/dlcfm.jpg')];
          break;
      }

      ImagePreview({
        images: images,
        closeable: true,
        onClose() {
          that.$nextTick(() => {
            that.continueDriver(stepIndex)
          })
        },
      });
    },

    // 步骤控制
    nextStep() {
      // 如果车头已存在，直接进入下一步，跳过验证
      if (this.isChetouExist && !this.chetouEditable) {
        this.currentStep = 1;
        // 只有当车挂所属车队为空时，才自动填充为车头所属车队
        // if (!this.trailer_sscd) {
        //   console.log('车挂所属车队为空，自动填充为车头所属车队');
        //   this.trailer_sscd = this.sscd;
        // }
        // 平滑滚动到顶部
        console.log('跳过车头验证,平滑滚动到顶部');
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        return;
      }

      // 验证车头表单 - 所有模式下都需要的字段
      if (!this.xsz_zb_fm_url) {
        Toast.fail('请上传行驶证正页');
        return false;
      }

      // 基本信息验证 - 所有模式下都需要的字段
      if (!this.chetouhao) {
        this.closeLoadingToast(); // 关闭加载提示
        Toast.fail('请填写车头号');
        return false;
      }
      if (!this.sscd) {
        this.closeLoadingToast(); // 关闭加载提示
        Toast.fail('请填写所属车队');
        return false;
      }
      
      // 根据vehicleUsage.typecode进行不同的验证
      if (this.vehicleUsage.typecode === '2') {
        // 验证额外的行驶证照片
      if (!this.xsz_fb_zm_url) {
        Toast.fail('请上传行驶证副页');
        return false;
      }
      if (!this.xsz_fb_fm_url) {
        Toast.fail('请上传行驶证副页反面');
        return false;
      }
      if (!this.xsz_zb_zm_url) {
        Toast.fail('请上传行驶证机动车照片');
        return false;
      }

        // 验证道路运输证
        if (!this.dlys_zm_url) {
          Toast.fail('请上传道路运输证正本正面图片');
          return false;
        }
        if (!this.dcl_zm_url) {
          Toast.fail('请上传道路运输证（待理证）正面图片');
          return false;
        }
        if (!this.dcl_fm_url) {
          Toast.fail('请上传道路运输证（待理证）反面图片');
          return false;
        }

        if (this.selectedData.length === 0) {
          Toast.fail('请选择道路运输证经营范围');
          return false;
        }
        
        // 验证额外的基本信息
      if (parseFloat(this.zhengbeizhiliang) <= 0) {
        Toast.fail('请填写正确的整备质量');
        return false;
        }
      }

      // 验证通过，进入下一步并平滑滚动到顶部
      this.currentStep = 1;

      // 只有当车挂所属车队为空时，才自动填充为车头所属车队
      // if (!this.trailer_sscd) {
      //   console.log('车挂所属车队为空，自动填充为车头所属车队');
      //   this.trailer_sscd = this.sscd;
      // }

      // 平滑滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      this.$nextTick(() => {
        store.state.isFirstTime && this.$driverObj.moveNext()
      })
    },
    prevStep() {
      // 不需要处理表单验证，因为按钮已经移到表单外部

      // 直接切换到第一步
      this.currentStep = 0;

      // 平滑滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      this.$nextTick(() => {
        store.state.isFirstTime && this.$driverObj.moveTo(0)
      })
    },

    // 车头信息表单方法
    changeVehicleUsage(data) {
      if (data) {
        this.vehicleUsage = data;
        if (store.state.isFirstTime) {
          if (data.typecode === '1') {
            this.steps.splice(1, this.steps.length - 1,...this.getPathA())
          } else if (data.typecode === '2') {
            this.steps.splice(1, this.steps.length - 1,...this.getPathB())
          }
          this.$nextTick(() => {
            this.$driverObj.moveTo(1); // 继续执行
          })
        }
        if (this.vehicleUsage.typecode == '1') {
          this.timeRequire = false;
        } else {
          this.timeRequire = true;
        }
      }
    },
    validatorChetou(val) {
      if (!val) {
        this.closeLoadingToast(); // 关闭加载提示
        Toast.fail('请填写车头号');
        return false;
      }
      return val;
    },
    validatorSscd(val) {
      if (!val) {
        this.closeLoadingToast(); // 关闭加载提示
        Toast.fail('请填写所属车队');
        return false;
      }
      return val;
    },
    validatorXingshizhenghdzzl(val) {
      if (!val) {
        this.closeLoadingToast(); // 关闭加载提示
        Toast.fail('请填写行驶证核定载质量');
        return false;
      }
      return val;
    },
    getXszYxq(xszYxq) {
      this.xingshizhengyxq = xszYxq;
    },
    getDlysYxq(xszYxq) {
      this.daoluyszyxq = xszYxq;
    },
    getDlysChosePz(selectedData) {
      this.selectedData = selectedData;
      this.pzArray = selectedData;
    },

    // 车头图片上传方法
     uploadXszZbZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const type = 'xsz_zb_zm';
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadXsz(type, formData).then( async function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;

            that.xsz_zb_zm_url = imageData.xingshizhengzbzmurl ? imageData.xingshizhengzbzmurl : "";
          that.xsz_zb_zm_image = imageData.xingshizhengzbzmurl ? [{
            url: weburl + '/' + imageData.xingshizhengzbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },

    uploadXszFbZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const type = 'xsz_fb_zm';
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.xsz_fb_zm_url = imageData.xingshizhengfbzmurl ? imageData.xingshizhengfbzmurl : "";
          that.xsz_fb_zm_image = imageData.xingshizhengfbzmurl ? [{
            url: weburl + '/' + imageData.xingshizhengfbzmurl
          }] : [];

          if (imageData.bpmStatus === "3") {
            var detail = imageData;
            that.mergeinfo(detail);
          } else {
            that.ctzl = imageData.ctzl ? imageData.ctzl : that.ctzl; // 车头质量
            that.xingshizhengyxq = imageData.xingshizhengyxq ? imageData.xingshizhengyxq : that.xingshizhengyxq; // 行驶证有效期
            that.zhengbeizhiliang = imageData.zhengbeizhiliang ? imageData.zhengbeizhiliang : that.zhengbeizhiliang; // 整备质量
            that.zongzhiliang = imageData.zongzhiliang ? imageData.zongzhiliang : that.zongzhiliang; // 总质量
            that.xingshizhenghdzzl = imageData.xingshizhenghdzzl ? imageData.xingshizhenghdzzl : that.xingshizhenghdzzl; // 行驶证核定载质量
          }
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    uploadXszFbFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const type = 'xsz_fb_fm';
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.xsz_fb_fm_url = imageData.xingshizhengfbfmurl ? imageData.xingshizhengfbfmurl : "";
          that.xsz_fb_fm_image = imageData.xingshizhengfbfmurl ? [{
            url: weburl + '/' + imageData.xingshizhengfbfmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    deleteXszZbZm() {
      this.xsz_zb_zm_url = "";
      this.xsz_zb_zm_image = [];
    },
    deleteXszZbFm() {
      this.xsz_zb_fm_url = "";
      this.xsz_zb_fm_image = [];
      this.chetouEditable = true;
      this.isChetouExist = false;
      this.useEditable = true

    },
    deleteXszFbZm() {
      this.xsz_fb_zm_url = "";
      this.xsz_fb_zm_image = [];
    },
    deleteXszFbFm() {
      this.xsz_fb_fm_url = "";
      this.xsz_fb_fm_image = [];
    },
    uploadDlysZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadDlys(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.dlys_zm_url = imageData.daoluyszzbzmurl ? imageData.daoluyszzbzmurl : "";
          that.dlys_zm_image = imageData.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData.daoluyszzbzmurl
          }] : [];
          if(imageData.daoluyszyxq) that.daoluyszyxq = imageData.daoluyszyxq;
          if(!imageData.chetouhao?.includes(that.chetouhao) && that.chetouhao) {
            Toast.fail("证件车辆与登记车头号不符合");
          }
        } else if(resData.respCode == "-1" && resData.data != null) {
          var imageData2 = resData.data;
          that.dlys_zm_url = imageData2.daoluyszzbzmurl ? imageData2.daoluyszzbzmurl : "";
          that.dlys_zm_image = imageData2.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData2.daoluyszzbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    uploadDclZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      const type = 'dcl_zm';

      api.uploadDcl(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.dcl_zm_url = imageData.daoluyszdlzmurl ? imageData.daoluyszdlzmurl : "";
          that.dcl_zm_image = imageData.daoluyszdlzmurl ? [{
            url: weburl + '/' + imageData.daoluyszdlzmurl
          }] : [];
          if(imageData.daoluyszyxq) that.daoluyszyxq = imageData.daoluyszyxq;
          if(!imageData.chetouhao?.includes(that.chetouhao) && that.chetouhao) {
            Toast.fail("证件车辆与登记车头号不符合");
          }
        } else if(resData.respCode == "-1" && resData.data != null) {
          var imageData2 = resData.data;
          that.dlys_zm_url = imageData2.daoluyszzbzmurl ? imageData2.daoluyszzbzmurl : "";
          that.dlys_zm_image = imageData2.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData2.daoluyszzbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    uploadDclFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      const type = 'dcl_fm';

      api.uploadDcl(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.dcl_fm_url = imageData.daoluyszdlfmurl ? imageData.daoluyszdlfmurl : "";
          that.dcl_fm_image = imageData.daoluyszdlfmurl ? [{
            url: weburl + '/' + imageData.daoluyszdlfmurl
          }] : [];
          if(imageData.daoluyszyxq) that.daoluyszyxq = imageData.daoluyszyxq;
          if(!imageData.chetouhao?.includes(that.chetouhao) && that.chetouhao) {
            Toast.fail("证件车辆与登记车头号不符合");
          }
        } else if(resData.respCode == "-1" && resData.data != null) {
          var imageData2 = resData.data;
          that.dlys_zm_url = imageData2.daoluyszzbzmurl ? imageData2.daoluyszzbzmurl : "";
          that.dlys_zm_image = imageData2.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData2.daoluyszzbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    deleteDlysZm() {
      this.dlys_zm_url = "";
      this.dlys_zm_image = [];
    },
    deleteDclZm() {
      this.dcl_zm_url = "";
      this.dcl_zm_image = [];
    },
    deleteDclFm() {
      this.dcl_fm_url = "";
      this.dcl_fm_image = [];
    },

    // 车挂信息表单方法
    validatorChegua(val) {
      if (!val) {
        this.closeLoadingToast(); // 关闭加载提示
        Toast.fail('请填写车挂号');
        return false;
      }
      return val;
    },
    validatorTrailerSscd(val) {
      if (!val) {
        this.closeLoadingToast(); // 关闭加载提示
        Toast.fail('请填写所属车队');
        return false;
      }
      return val;
    },
    validatorSfjzx(val) {
      if (!val) {
        this.closeLoadingToast(); // 关闭加载提示
        Toast.fail('请选择是否为集装箱');
        return false;
      }
      return val;
    },
    validatorTrailerZbzl(val) {
      if (!val) {
        this.closeLoadingToast(); // 关闭加载提示
        Toast.fail('请填写整备质量');
        return false;
      }
      return val;
    },
    validatorTrailerXingshizhenghdzzl(val) {
      if (!val) {
        this.closeLoadingToast(); // 关闭加载提示
        Toast.fail('请填写行驶证核定载质量');
        return false;
      }
      return val;
    },
    validatorCssl(val) {
      if (!val) {
        this.closeLoadingToast(); // 关闭加载提示
        Toast.fail('请选择隔舱数量');
        return false;
      }
      return val;
    },
    onCsslConfirm(value) {
      this.cssl = value;
      this.showCsslPicker = false;
    },
    validatorGuantitiji(val) {
      if (!val) {
        this.closeLoadingToast(); // 关闭加载提示
        Toast.fail('请填写罐体体积');
        return false;
      }
      return val;
    },
    getTrailerXszYxq(xszYxq) {
      this.trailer_xingshizhengyxq = xszYxq;
    },
    getTrailerDlysYxq(xszYxq) {
      this.trailer_daoluyszyxq = xszYxq;
    },
    getTrailerDlysChosePz(selectedData) {
      this.trailer_selectedData = selectedData;
      this.trailer_pzArray = selectedData;
    },
    getGuanjianyxq(xszYxq) {
      this.guanjianyxq = xszYxq;
    },
    getGtChosePz(selectedData) {
      this.gtSelectedData = selectedData;
      this.gtPzArray = selectedData;
    },

    // 车挂图片上传方法
    uploadTrailerXszZbZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const type = 'xsz_zb_zm';
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadCheguaXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.trailer_xsz_zb_zm_url = imageData.xingshizhengzbzmurl ? imageData.xingshizhengzbzmurl : "";
          that.trailer_xsz_zb_zm_image = imageData.xingshizhengzbzmurl ? [{
            url: weburl + '/' + imageData.xingshizhengzbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },

    uploadTrailerXszFbZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const type = 'xsz_fb_zm';
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadCheguaXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.trailer_xsz_fb_zm_url = imageData.xingshizhengfbzmurl ? imageData.xingshizhengfbzmurl : "";
          that.trailer_xsz_fb_zm_image = imageData.xingshizhengfbzmurl ? [{
            url: weburl + '/' + imageData.xingshizhengfbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    uploadTrailerXszFbFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const type = 'xsz_fb_fm';
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadCheguaXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.trailer_xsz_fb_fm_url = imageData.xingshizhengfbfmurl ? imageData.xingshizhengfbfmurl : "";
          that.trailer_xsz_fb_fm_image = imageData.xingshizhengfbfmurl ? [{
            url: weburl + '/' + imageData.xingshizhengfbfmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    deleteTrailerXszZbZm() {
      this.trailer_xsz_zb_zm_url = "";
      this.trailer_xsz_zb_zm_image = [];
    },
    deleteTrailerXszZbFm() {
      this.trailer_xsz_zb_fm_url = "";
      this.trailer_xsz_zb_fm_image = [];
      this.cheguaEditable = true;
      this.isCheguaExist = false;
    },
    deleteTrailerXszFbZm() {
      this.trailer_xsz_fb_zm_url = "";
      this.trailer_xsz_fb_zm_image = [];
    },
    deleteTrailerXszFbFm() {
      this.trailer_xsz_fb_fm_url = "";
      this.trailer_xsz_fb_fm_image = [];
    },
    uploadTrailerDlysZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadCgDlys(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.trailer_dlys_zm_url = imageData.daoluyszzbzmurl ? imageData.daoluyszzbzmurl : "";
          that.trailer_dlys_zm_image = imageData.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData.daoluyszzbzmurl
          }] : [];
          if(imageData.daoluyszyxq) that.trailer_daoluyszyxq = imageData.daoluyszyxq;
          if(!imageData.cheguahao?.includes(that.cheguahao) && that.cheguahao) {
            Toast.fail("证件车辆与登记车挂号不符合");
          }
        } else if(resData.respCode == "-1" && resData.data != null) {
          var imageData2 = resData.data;
          that.trailer_dlys_zm_url = imageData2.daoluyszzbzmurl ? imageData2.daoluyszzbzmurl : "";
          that.trailer_dlys_zm_image = imageData2.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData2.daoluyszzbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    uploadTrailerDclZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      const type = 'dcl_zm';

      api.uploadCgDcl(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.trailer_dcl_zm_url = imageData.daoluyszdlzmurl ? imageData.daoluyszdlzmurl : "";
          that.trailer_dcl_zm_image = imageData.daoluyszdlzmurl ? [{
            url: weburl + '/' + imageData.daoluyszdlzmurl
          }] : [];
          if(imageData.daoluyszyxq) that.trailer_daoluyszyxq = imageData.daoluyszyxq;
          if(!imageData.cheguahao?.includes(that.cheguahao) && that.cheguahao) {
            Toast.fail("证件车辆与登记车挂号不符合");
          }
        } else if(resData.respCode == "-1" && resData.data != null) {
          var imageData2 = resData.data;
          that.trailer_dlys_zm_url = imageData2.daoluyszzbzmurl ? imageData2.daoluyszzbzmurl : "";
          that.trailer_dlys_zm_image = imageData2.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData2.daoluyszzbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    uploadTrailerDclFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      const type = 'dcl_fm';

      api.uploadCgDcl(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.trailer_dcl_fm_url = imageData.daoluyszdlfmurl ? imageData.daoluyszdlfmurl : "";
          that.trailer_dcl_fm_image = imageData.daoluyszdlfmurl ? [{
            url: weburl + '/' + imageData.daoluyszdlfmurl
          }] : [];
          if(imageData.daoluyszyxq) that.trailer_daoluyszyxq = imageData.daoluyszyxq;
          if(!imageData.cheguahao?.includes(that.cheguahao) && that.cheguahao) {
            Toast.fail("证件车辆与登记车挂号不符合");
          }
        } else if(resData.respCode == "-1" && resData.data != null) {
          var imageData2 = resData.data;
          that.trailer_dlys_zm_url = imageData2.daoluyszzbzmurl ? imageData2.daoluyszzbzmurl : "";
          that.trailer_dlys_zm_image = imageData2.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData2.daoluyszzbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    deleteTrailerDlysZm() {
      this.trailer_dlys_zm_url = "";
      this.trailer_dlys_zm_image = [];
    },
    deleteTrailerDclZm() {
      this.trailer_dcl_zm_url = "";
      this.trailer_dcl_zm_image = [];
    },
    deleteTrailerDclFm() {
      this.trailer_dcl_fm_url = "";
      this.trailer_dcl_fm_image = [];
    },

    // 罐体相关方法
    uploadGtImage(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const weburl = that.GLOBAL.weburl;

      let formData = new FormData();
      if (Array.isArray(file)) {
        file.forEach((item) => {
          formData.append("uploadpics", item.file);
        })
      } else {
        formData.append("uploadpics", file.file);
      }

      formData.append("ctid", '');
      api.uploadGtImage(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data.guanjianbgurl;
          var guanjianbgImageArr = that.guanjianbgImageArr;
          var guanjianbgurlArr = that.guanjianbgurlArr;

          var imageDataArr = imageData.split(',');

          for (var i = 0; i < imageDataArr.length; i++) {
            if (guanjianbgImageArr.length > 0) {
              guanjianbgImageArr.push({
                'url': weburl + '/' + imageDataArr[i]
              });
              guanjianbgurlArr.push(imageDataArr[i]);
            } else {
              guanjianbgImageArr = imageDataArr[i] ? [{
                url: weburl + '/' + imageDataArr[i]
              }] : [];
              guanjianbgurlArr = imageDataArr[i] ? [imageDataArr[i]] : [];
            }
          }

          that.guanjianbgimage = that.guanjianbgImageArr = guanjianbgImageArr;
          that.guanjianbgurlArr = guanjianbgurlArr;
          if(resData.data.guanjianyxq) that.guanjianyxq = resData.data.guanjianyxq;
          if(resData.data.guantitiji) that.guantitiji = resData.data.guantitiji;
          if(!imageData.cheguahao?.includes(that.cheguahao) && that.cheguahao) {
            Toast.fail("证件车辆与登记车挂号不符合");
          }
        } else if(resData.respCode == "-1" && resData.data != null) {
          var imageData2 = resData.data.guanjianbgurl;
          var guanjianbgImageArr2 = that.guanjianbgImageArr;
          var guanjianbgurlArr2 = that.guanjianbgurlArr;

          var imageDataArr2 = imageData2.split(',');

          for (var i2 = 0; i2 < imageDataArr2.length; i2++) {
            if (guanjianbgImageArr2.length > 0) {
              guanjianbgImageArr2.push({
                'url': weburl + '/' + imageDataArr2[i2]
              });
              guanjianbgurlArr2.push(imageDataArr2[i2]);
            } else {
              guanjianbgImageArr2 = imageDataArr2[i2] ? [{
                url: weburl + '/' + imageDataArr2[i2]
              }] : [];
              guanjianbgurlArr2 = imageDataArr2[i2] ? [imageDataArr2[i2]] : [];
            }
          }

          that.guanjianbgimage = that.guanjianbgImageArr = guanjianbgImageArr2;
          that.guanjianbgurlArr = guanjianbgurlArr2;
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function() {
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    deleteGtImage(file) {
      const that = this;
      const weburl = that.GLOBAL.weburl;
      var guanjianbgImageArr = that.guanjianbgImageArr;
      var guanjianbgNewImageArr = [];
      var guanjianbgNewUrlArr = [];
      for (var i = 0; i < guanjianbgImageArr.length; i++) {
        if (guanjianbgImageArr[i].url != file.url) {
          guanjianbgNewImageArr.push(guanjianbgImageArr[i]);
          var path = guanjianbgImageArr[i].url.replace(weburl, '');
          guanjianbgNewUrlArr.push(path);
        }
      }
      that.guanjianbgimage = that.guanjianbgImageArr = guanjianbgNewImageArr;
      that.guanjianbgurlArr = guanjianbgNewUrlArr;
    },
    changeGtMaterial(data) {
      this.guanticaizhi = data;
    },

    // 舱室相关方法
    setCabin(value) {
      this.cabinValue = value;
    },
    getCsValue1(value) {
      this.cangshilifang1 = value;
    },
    getCsValue2(value) {
      this.cangshilifang2 = value;
    },
    getCsValue3(value) {
      this.cangshilifang3 = value;
    },
    // 合并车挂信息
    // 检查车头是否存在
    searchChetou(search) {
      const that = this;
      api.searchChetou(search).then(function(resData) {
        const res = JSON.parse(resData);
        if (res.respCode == "0") {
          const chetouItems = res.data;
          if (chetouItems.length > 0) {
            that.isChetouExist = true;
          } else {
            that.isChetouExist = false;
          }
        } else {
          that.isChetouExist = false;
        }
      }).catch(function(err) {
        console.log(err);
        that.isChetouExist = false;
      });
    },

    // 检查车挂是否存在
    searchChegua(search) {
      const that = this;
      api.searchChegua(search).then(function(resData) {
        const res = JSON.parse(resData);
        if (res.respCode == "0") {
          const cheguaItems = res.data;
          if (cheguaItems.length > 0) {
            that.isCheguaExist = true;
          } else {
            that.isCheguaExist = false;
          }
        } else {
          that.isCheguaExist = false;
        }
      }).catch(function(err) {
        console.log(err);
        that.isCheguaExist = false;
      });
    },

    mergeTrailerInfo(detail) {
      const that = this;
      const weburl = that.GLOBAL.weburl;

      // 更新基本信息
      that.cheguahao = detail.cheguahao ? detail.cheguahao : that.cheguahao;
      that.trailer_xingshizhengyxq = detail.xingshizhengyxq ? detail.xingshizhengyxq : that.trailer_xingshizhengyxq;
      that.trailer_sscd = detail.sscd ? detail.sscd : that.trailer_sscd;
      that.trailer_zhengbeizhiliang = detail.zhengbeizhiliang ? detail.zhengbeizhiliang : that.trailer_zhengbeizhiliang;
      that.trailer_chejiahao = detail.chejiahao ? detail.chejiahao : that.trailer_chejiahao;
      that.trailer_xingshizhenghdzzl = detail.xingshizhenghdzzl ? detail.xingshizhenghdzzl : that.trailer_xingshizhenghdzzl;

      // 更新图片URL
      that.trailer_xsz_zb_zm_url = detail.xingshizhengzbzmurl ? detail.xingshizhengzbzmurl : that.trailer_xsz_zb_zm_url;
      that.trailer_xsz_zb_fm_url = detail.xingshizhengzbfmurl ? detail.xingshizhengzbfmurl : that.trailer_xsz_zb_fm_url;
      that.trailer_xsz_fb_zm_url = detail.xingshizhengfbzmurl ? detail.xingshizhengfbzmurl : that.trailer_xsz_fb_zm_url;
      that.trailer_xsz_fb_fm_url = detail.xingshizhengfbfmurl ? detail.xingshizhengfbfmurl : that.trailer_xsz_fb_fm_url;

      // 更新图片对象
      that.trailer_xsz_zb_zm_image = detail.xingshizhengzbzmurl ? [{
        url: weburl + '/' + detail.xingshizhengzbzmurl
      }] : that.trailer_xsz_zb_zm_image;

      that.trailer_xsz_zb_fm_image = detail.xingshizhengzbfmurl ? [{
        url: weburl + '/' + detail.xingshizhengzbfmurl
      }] : that.trailer_xsz_zb_fm_image;

      that.trailer_xsz_fb_zm_image = detail.xingshizhengfbzmurl ? [{
        url: weburl + '/' + detail.xingshizhengfbzmurl
      }] : that.trailer_xsz_fb_zm_image;

      that.trailer_xsz_fb_fm_image = detail.xingshizhengfbfmurl ? [{
        url: weburl + '/' + detail.xingshizhengfbfmurl
      }] : that.trailer_xsz_fb_fm_image;
    },
    submitFailed(e){
      Toast.fail(e.errors[0].message);
    },

    // AI 对话危货新司机绑定流程：绑定成功后打标，首页 tabbar 据此显示「我的」
    markAiChatVehicleBoundIfNeeded() {
      if (this.$route.query.source === 'aichat') {
        this.$store.commit('set_aiChatVehicleBound', true);
      }
    },

    // 提交所有表单
    submitAll() {
      this.destroyDriver()
      console.log('提交所有表单');
      console.log('提交前 - 车头所属车队:', this.sscd);
      console.log('提交前 - 车挂所属车队:', this.trailer_sscd);
      const that = this;
      
      // 显示提交中的加载提示
      Toast.loading({
        message: '提交中...',
        forbidClick: true, // 禁止点击背景
        duration: 0 // 持续显示，不自动关闭
      });
      // 定义当前日期变量，避免多次重复创建
      const currentDate = new Date();

   

      // ================== 验证车头信息 ==================
      // 如果车头不可编辑（已存在），则跳过车头验证
      if (!this.chetouEditable) {
        console.log("车头已存在，跳过车头验证");
      } else {
              // 验证车头表单 - 所有模式下都需要的字段
        if (!this.xsz_zb_fm_url) {
        this.closeLoadingToast(); // 关闭加载提示
          Toast.fail('请上传车头行驶证正页');
          return false;
        }
        
        // 基本信息验证 - 所有模式下都需要的字段
        if (!this.chetouhao) {
          Toast.fail('请填写车头号');
          return false;
        }
        if (!this.sscd) {
          Toast.fail('请填写所属车队');
          return false;
        }

        // 仅当vehicleUsage.typecode为2时验证额外的字段
        if (this.vehicleUsage.typecode === '2') {
          // 验证额外的行驶证照片
          if (!this.xsz_fb_zm_url) {
            Toast.fail('请上传车头行驶证副页');
            return false;
          }
          if (!this.xsz_fb_fm_url) {
            Toast.fail('请上传车头行驶证副页反面');
            return false;
          }
          if (!this.xsz_zb_zm_url) {
            Toast.fail('请上传车头行驶证机动车照片');
            return false;
          }

          // 验证整备质量
          if (parseFloat(this.zhengbeizhiliang) <= 0) {
            this.closeLoadingToast(); // 关闭加载提示
            Toast.fail('请填写正确的整备质量');
            return false;
          }
        }
        
        // 验证通过，进入下一步并平滑滚动到顶部
        this.currentStep = 1;

        // 只有当车挂所属车队为空时，才自动填充为车头所属车队
        if (!this.trailer_sscd) {
          console.log('车挂所属车队为空，自动填充为车头所属车队');
          this.trailer_sscd = this.sscd;
        }

        // 平滑滚动到顶部
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }

      // ================== 验证车挂信息 ==================
      // 如果车挂不可编辑（已存在），则跳过车挂验证
      if (!this.cheguaEditable) {
        console.log("车挂已存在，跳过车挂验证");
      } else {
        // 验证车挂表单 - 所有模式下都需要的字段
        if (!this.trailer_xsz_zb_fm_url) {
          Toast.fail('请上传车挂行驶证正页');
          return false;
        }
        
        // 基本信息验证 - 所有模式下都需要的字段
        if (!this.cheguahao) {
          Toast.fail('请填写车挂号');
          return false;
        }
        if (this.cheguahao.length < 5) {
          Toast.fail("请输入正确的车挂号");
          return false;
        }
        if (!this.trailer_sscd) {
          Toast.fail('请填写车挂所属车队');
          return false;
        }
        if (!this.sfjzx) {
          Toast.fail('请确认是否集装箱');
          return false;
        }

        // 罐体材质验证 - 所有模式下都需要
        if (!this.guanticaizhi) {
          Toast.fail('请选择罐体材质');
          return false;
        }
        
        // 验证货仓数量 - 现在两种模式都验证
        if (!this.cssl) {
          Toast.fail('请选择隔舱数量');
          return false;
        }

        // 根据vehicleUsage.typecode验证不同的字段
        if (this.vehicleUsage.typecode === '2') {
          // 验证额外的行驶证照片
          if (!this.trailer_xsz_fb_zm_url) {
            Toast.fail('请上传车挂行驶证副页');
            return false;
          }
          if (!this.trailer_xsz_fb_fm_url) {
            Toast.fail('请上传车挂行驶证副页反面');
          return false;
        }
          if (!this.trailer_xsz_zb_zm_url) {
            Toast.fail('请上传车挂行驶证机动车照片');
          return false;
        }
          
          // 验证舱室信息
          if (!this.cabinValue) {
            Toast.fail('请选择舱室');
          return false;
        }
          
          // 验证罐体体积
          if (parseFloat(this.guantitiji) <= 0) {
            Toast.fail('请填写正确的罐体体积');
          return false;
        }
          
          // 验证额外的基本信息
        if (parseFloat(this.trailer_zhengbeizhiliang) <= 0) {
          Toast.fail('请填写车挂正确的整备质量');
          return false;
        }
        if (parseFloat(this.trailer_xingshizhenghdzzl) <= 0) {
          Toast.fail('请填写车挂正确的行驶证核定载质量');
          return false;
        }
        }
      }

      // ================== 验证日期 ==================
      // 只有在相应车辆可编辑时才验证日期，且仅当vehicleUsage.typecode为2时
      if (this.chetouEditable && this.vehicleUsage.typecode === '2') {
        // 验证车头行驶证日期
        if (!this.xingshizhengyxq) {
          Toast.fail('请选择车头行驶证有效期');
          return false;
        }
        const headXszDate = new Date(this.xingshizhengyxq);
        if (headXszDate < currentDate) {
          Toast.fail('车头行驶证有效期不能小于当前日期');
          return false;
        }
      }

      if (this.cheguaEditable && this.vehicleUsage.typecode === '2') {
        // 验证车挂行驶证日期
        if (!this.trailer_xingshizhengyxq) {
          Toast.fail('请选择车挂行驶证有效期');
          return false;
        }
        const trailerXszDate = new Date(this.trailer_xingshizhengyxq);
        if (trailerXszDate < currentDate) {
          Toast.fail('车挂行驶证有效期不能小于当前日期');
          return false;
        }
      }

      // 如果是蒸洗+作业类型且车挂可编辑，验证车挂道路运输证
      if (this.vehicleUsage.typecode == '2' && this.cheguaEditable) {
        if (!this.trailer_dlys_zm_url) {
          Toast.fail('请上传车挂道路运输证正本正面图片');
          return false;
        }
        if (!this.trailer_dcl_zm_url) {
          Toast.fail('请上传车挂道路运输证（待理证）正面图片');
          return false;
        }
        if (!this.trailer_dcl_fm_url) {
          Toast.fail('请上传车挂道路运输证（待理证）反面图片');
          return false;
        }

        if (this.trailer_selectedData.length === 0) {
          Toast.fail('请选择车挂道路运输证经营范围');
          return false;
        }

        var guanjianbgurlArr = that.guanjianbgurlArr;
        var gtSelectedData = that.gtSelectedData;

        if (gtSelectedData.length > 0) {
          // 根据道路运输证经营范围判断是否是只装普通货物车挂
          var guanjianjyfw = "";
          for (var j = 0; j < gtSelectedData.length; j++) {
            guanjianjyfw += gtSelectedData[j] + "|";
          }
          // 去掉最后一个分隔符
          if (guanjianjyfw.length > 0) {
            guanjianjyfw = guanjianjyfw.substr(0, guanjianjyfw.length - 1);
          }

          // 验证罐检相关信息
          return new Promise((resolve, reject) => {
            api.isgeneralgood(encodeURIComponent(guanjianjyfw)).then(function(res) {
              var resData = JSON.parse(res);
              if (resData.respCode == "0") {
                if (resData.data == 'N') {
                  if (guanjianbgurlArr.length == 0) {
                    Toast.fail('请上传罐检图片');
                    reject(false);
                    return;
                  }

                  if (!that.guanjianyxq) {
                    Toast.fail('请选择罐检有效期');
                    reject(false);
                    return;
                  }

                  // 验证罐检有效期
                  const guanjianyxqDate = new Date(that.guanjianyxq);
                  if (guanjianyxqDate < currentDate) {
                    Toast.fail('罐检有效期不能小于当前日期');
                    reject(false);
                    return;
                  }

                  if (gtSelectedData.length == 0) {
                    Toast.fail('请选择罐检经营范围');
                    reject(false);
                    return;
                  }
                }
                // 验证通过，开始提交数据
                resolve(true);
                that.loadingBtn = true;
                
                // 根据车头和车挂是否存在决定执行顺序
                console.log("车头存在状态:", that.isChetouExist, "车挂存在状态:", that.isCheguaExist);
                
                if (!that.isChetouExist || !that.isCheguaExist) {
                  // 车头或车挂至少有一个不存在，先创建不存在的车辆
                  console.log("车头或车挂至少有一个不存在，先创建不存在的车辆");
                  if (!that.isChetouExist) {
                    // 车头不存在，先创建车头
                    that.createChetou();
                  } else if (!that.isCheguaExist) {
                    // 车挂不存在，先创建车挂
                    that.createChegua();
                  }
                } else {
                  // 车头和车挂都已存在，先执行绑定
                  console.log("车头和车挂都已存在，先执行绑定");
                  that.bindVehicle();
                }
              } else {
                Dialog.alert({
                  message: resData.message,
                });
                reject(false);
              }
            }).catch(function(err) {
              console.log(err);
              Toast.fail('验证罐检信息失败');
              reject(false);
            });
          }).catch(() => false);
        } else {
          // 没有罐检经营范围，根据车头和车挂是否存在决定执行顺序
          that.loadingBtn = true;
          
          console.log("车头存在状态:", that.isChetouExist, "车挂存在状态:", that.isCheguaExist);
          
          if (!that.isChetouExist || !that.isCheguaExist) {
            // 车头或车挂至少有一个不存在，先创建不存在的车辆
            console.log("车头或车挂至少有一个不存在，先创建不存在的车辆");
            if (!that.isChetouExist) {
              // 车头不存在，先创建车头
              that.createChetou();
            } else if (!that.isCheguaExist) {
              // 车挂不存在，先创建车挂
              that.createChegua();
        }
      } else {
            // 车头和车挂都已存在，先执行绑定
            console.log("车头和车挂都已存在，先执行绑定");
            that.bindVehicle();
          }
        }
      } else {
        // 不是蒸洗+作业类型或车挂不可编辑，根据车头和车挂是否存在决定执行顺序
        that.loadingBtn = true;
        
        console.log("车头存在状态:", that.isChetouExist, "车挂存在状态:", that.isCheguaExist);
        
        if (!that.isChetouExist || !that.isCheguaExist) {
          // 车头或车挂至少有一个不存在，先创建不存在的车辆
          console.log("车头或车挂至少有一个不存在，先创建不存在的车辆");
          if (!that.isChetouExist) {
            // 车头不存在，先创建车头
            that.createChetou();
          } else if (!that.isCheguaExist) {
            // 车挂不存在，先创建车挂
            that.createChegua();
          }
        } else {
          // 车头和车挂都已存在，先执行绑定
          console.log("车头和车挂都已存在，先执行绑定");
          that.bindVehicle();
        }
      }
    },

    // 绑定车头与车挂
    bindVehicle() {
      console.log('绑定车头与车挂');
      console.log('绑定前 - 车头所属车队:', this.sscd);
      console.log('绑定前 - 车挂所属车队:', this.trailer_sscd);
      const that = this;
      const openid = localStorage['wx_openid'];
      const chetouhao = that.chetouhao;
      const cheguahao = that.cheguahao;

      // 在绑定前获取最新的车头和车挂数据用于比较
      that.fetchVehicleData().then(() => {
        // 调用绑定API
        api.bindVehicle(openid, chetouhao, cheguahao).then(function(resData) {
        const res = JSON.parse(resData);
          if (res.respCode == "0") {
            // 清掉首页车辆缓存，让回首页时重新拉最新行驶证有效期
            localStorage.removeItem('vehicleInfo');
            console.log("车头车挂绑定成功，继续处理数据更新");
            // 绑定成功后，标记需要刷新车挂数据
            that.refreshCheguaData = true;
            
            // 检查是否需要更新车头或车挂数据
            if (that.chetouDataChanged) {
              // 车头数据有变化，需要更新
              that.updateChetou();
            } else if (that.cheguaDataChanged) {
              // 车挂数据有变化，需要更新
              that.updateChegua();
        } else {
              // 没有数据需要更新，直接提交审核
              that.submitChetou();
            }
          } else {
            that.loadingBtn = false;
            that.closeLoadingToast(); // 关闭加载提示
            store.commit('set_firstTime')
            Dialog.alert({
              message: (res.message && res.message.includes('未查询到可用的用户信息来绑定车辆')) ? '该用户openid不可用' : (res.message || '绑定失败，可能车头或车挂已被绑定'),
            });
          }
        }).catch(function(err) {
          console.log(err);
          that.loadingBtn = false;
          that.closeLoadingToast(); // 关闭加载提示
          store.commit('set_firstTime')
          Toast.fail('绑定失败，请刷新页面重试');
        });
      }).catch(err => {
        console.log("获取车辆数据失败:", err);
        that.loadingBtn = false;
        that.closeLoadingToast(); // 关闭加载提示
        store.commit('set_firstTime')
        Toast.fail('获取车辆数据失败，请重试');
      });
    },
    
    // 获取最新的车头和车挂数据并检查数据变化
    fetchVehicleData() {
      const that = this;
      console.log("获取并检查车辆数据变化");
      
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
                    console.log("车头校验", that.chetouhao, that.isChetouExist)
            // 如果车头存在，使用车头号查询信息
            if (that.isChetouExist && that.chetouhao) {
              try {
                // 使用searchChetou通过车头号查询，而不是用ID查询
                const chetouResponse = await api.searchChetou(that.chetouhao);
                              const chetouData = typeof chetouResponse === 'string'
                  ? JSON.parse(chetouResponse)
                  : chetouResponse;
                
                if (chetouData && chetouData.respCode === "0" && chetouData.data && chetouData.data.length > 0) {
                                    // searchChetou返回的是数组，取第一个元素
                  that.originalChetouData = JSON.parse(JSON.stringify(chetouData.data[0]));
                  // 确保有chetouId
                  that.chetouId = chetouData.data[0].id;
                  // 保存原始的道路运输证经营范围用于后续审核判断
                  that.originalChetouDaoluyszjyfw = chetouData.data[0].daoluyszjyfw || "";
                  console.log("已获取最新车头详细信息:", that.originalChetouData);
                
                // 检查车头数据是否有变化
                that.chetouDataChanged = that.compareChetouData();
                console.log("车头数据是否有变化:", that.chetouDataChanged);
              }
            } catch (error) {
              console.error("获取车头详细信息失败:", error);
            }
          }
          
          // 如果车挂存在，获取车挂数据并比较
          if (that.isCheguaExist && that.cheguaId) {
            try {
              const cheguaResponse = await api.getCheguaBeianDetail(that.cheguaId);
              const cheguaData = typeof cheguaResponse === 'string'
                ? JSON.parse(cheguaResponse)
                : cheguaResponse;
              
              if (cheguaData && cheguaData.respCode === "0" && cheguaData.data) {
                that.originalCheguaData = JSON.parse(JSON.stringify(cheguaData.data));
                // 保存原始的道路运输证经营范围和罐检经营范围用于后续审核判断
                that.originalCheguaDaoluyszjyfw = cheguaData.data.daoluyszjyfw || "";
                that.originalCheguaGuanjianjyfw = cheguaData.data.guanjianjyfw || "";
                console.log("已获取最新车挂详细信息:", that.originalCheguaData);
                
                // 检查车挂数据是否有变化
                that.cheguaDataChanged = that.compareCheguaData();
                console.log("车挂数据是否有变化:", that.cheguaDataChanged);
              }
            } catch (error) {
              console.error("获取车挂详细信息失败:", error);
            }
          }
          
          resolve();
        } catch (error) {
          console.error("获取车辆数据失败:", error);
          reject(error);
        }
      });
    },
    
    // 比较车头数据
    compareChetouData() {
      const that = this;
      if (!that.originalChetouData) return false;
      
      console.log("比较车头数据变化");
      
      // 构建当前车头数据对象用于比较
      const currentChetouData = {
        chetouhao: that.chetouhao,
        sscd: that.sscd,
        vehicleUsage: that.vehicleUsage.typecode,
        // 排除xingshizhengzbfmurl字段，因为它必然不同
        // xingshizhengzbfmurl: that.xsz_zb_fm_url,
        chejiahao: that.chejiahao,
        ctzl: that.ctzl,
        zhengbeizhiliang: that.zhengbeizhiliang,
        zongzhiliang: that.zongzhiliang,
        xingshizhenghdzzl: that.xingshizhenghdzzl,
        xingshizhengyxq: that.xingshizhengyxq
      };
      
      // 添加蒸洗+作业类型特有的字段
      if (that.vehicleUsage.typecode === '2') {
        currentChetouData.xingshizhengzbzmurl = that.xsz_zb_zm_url;
        currentChetouData.xingshizhengfbzmurl = that.xsz_fb_zm_url;
        currentChetouData.xingshizhengfbfmurl = that.xsz_fb_fm_url;
        
        // 处理道路运输证经营范围
        let daoluyszjyfw = "";
        if (that.selectedData.length > 0) {
          daoluyszjyfw = that.selectedData.join('|');
        }
        currentChetouData.daoluyszjyfw = daoluyszjyfw;
        
        // 检查道路运输证经营范围是否有变化，记录变化
        if (daoluyszjyfw !== that.originalChetouDaoluyszjyfw) {
          console.log("车头道路运输证经营范围发生变化");
          console.log("原始值:", that.originalChetouDaoluyszjyfw);
          console.log("当前值:", daoluyszjyfw);
          that.chetouDaoluyszjyfwChanged = true; // 设置变化标记
        }
        
        currentChetouData.daoluyszyxq = that.daoluyszyxq;
        currentChetouData.daoluyszzbzmurl = that.dlys_zm_url;
        currentChetouData.daoluyszdlzmurl = that.dcl_zm_url;
        currentChetouData.daoluyszdlfmurl = that.dcl_fm_url;
        currentChetouData.beizhu = that.beizhuHead;
      }
      
      // 逐个比较字段
      const fieldsToCompare = Object.keys(currentChetouData);
      for (const field of fieldsToCompare) {
        // 跳过xingshizhengzbfmurl字段
        if (field === 'xingshizhengzbfmurl') continue;
        
        const currentValue = currentChetouData[field];
        const originalValue = that.originalChetouData[field];
        
        // 处理数值类型
        if (typeof currentValue === 'number' || typeof originalValue === 'number') {
          // 将空字符串或null/undefined转为0进行比较
          const currVal = currentValue === "" || currentValue === null || currentValue === undefined ? 0 : Number(currentValue);
          const origVal = originalValue === "" || originalValue === null || originalValue === undefined ? 0 : Number(originalValue);
          
          if (currVal !== origVal) {
            console.log(`车头字段 ${field} 发生变化: 原值=${originalValue}, 当前值=${currentValue}`);
            return true;
          }
        } 
        // 处理数组或对象类型
        else if (typeof currentValue === 'object' || typeof originalValue === 'object') {
          // 将null/undefined转为空字符串进行比较
          const currVal = currentValue === null || currentValue === undefined ? "" : JSON.stringify(currentValue);
          const origVal = originalValue === null || originalValue === undefined ? "" : JSON.stringify(originalValue);
          
          if (currVal !== origVal) {
            console.log(`车头字段 ${field} 发生变化: 原值=${originalValue}, 当前值=${currentValue}`);
            return true;
          }
        }
        // 处理字符串类型
        else {
          // 将null/undefined转为空字符串进行比较
          const currVal = currentValue === null || currentValue === undefined ? "" : String(currentValue);
          const origVal = originalValue === null || originalValue === undefined ? "" : String(originalValue);
          
          if (currVal !== origVal) {
            console.log(`车头字段 ${field} 发生变化: 原值=${originalValue}, 当前值=${currentValue}`);
            return true;
          }
        }
      }
      
      return false;
    },
    
    // 比较车挂数据
    compareCheguaData() {
      const that = this;
      if (!that.originalCheguaData) return false;
      
      console.log("比较车挂数据变化");
      
      // 构建当前车挂数据对象用于比较
      const currentCheguaData = {
        cheguahao: that.cheguahao,
        sscd: that.trailer_sscd,
        guanticaizhi: that.guanticaizhi,
        sfjzx: that.sfjzx,
        vehicleUsage: that.vehicleUsage.typecode,
        // 排除xingshizhengzbfmurl字段，因为它必然不同
        // xingshizhengzbfmurl: that.trailer_xsz_zb_fm_url
        cssl: that.cssl // 添加隔仓数量字段
      };
      
      // 根据车辆用途添加不同的字段
      if (that.vehicleUsage.typecode === '1') {
        // 精简模式下的特有字段
        currentCheguaData.beizhu = that.beizhu;
      } else if (that.vehicleUsage.typecode === '2') {
        // 完整模式下的额外字段
        currentCheguaData.xingshizhengyxq = that.trailer_xingshizhengyxq;
        currentCheguaData.zhengbeizhiliang = that.trailer_zhengbeizhiliang;
        currentCheguaData.chejiahao = that.trailer_chejiahao;
        currentCheguaData.xingshizhenghdzzl = that.trailer_xingshizhenghdzzl;
        currentCheguaData.xingshizhengzbzmurl = that.trailer_xsz_zb_zm_url;
        currentCheguaData.xingshizhengfbzmurl = that.trailer_xsz_fb_zm_url;
        currentCheguaData.xingshizhengfbfmurl = that.trailer_xsz_fb_fm_url;
        
        // 处理道路运输证经营范围
        let trailerDaoluyszjyfw = "";
        if (that.trailer_selectedData.length > 0) {
          trailerDaoluyszjyfw = that.trailer_selectedData.join('|');
        }
        currentCheguaData.daoluyszjyfw = trailerDaoluyszjyfw;
        
        // 检查道路运输证经营范围是否有变化，记录变化
        if (trailerDaoluyszjyfw !== that.originalCheguaDaoluyszjyfw) {
          console.log("车挂道路运输证经营范围发生变化");
          console.log("原始值:", that.originalCheguaDaoluyszjyfw);
          console.log("当前值:", trailerDaoluyszjyfw);
          that.cheguaDaoluyszjyfwChanged = true; // 设置变化标记
        }
        
        currentCheguaData.daoluyszyxq = that.trailer_daoluyszyxq;
        currentCheguaData.daoluyszzbzmurl = that.trailer_dlys_zm_url;
        currentCheguaData.daoluyszdlzmurl = that.trailer_dcl_zm_url;
        currentCheguaData.daoluyszdlfmurl = that.trailer_dcl_fm_url;
        
        // 处理罐检经营范围
        let guanjianjyfw = "";
        if (that.gtSelectedData.length > 0) {
          guanjianjyfw = that.gtSelectedData.join('|');
        }
        currentCheguaData.guanjianjyfw = guanjianjyfw;
        
        // 检查罐检经营范围是否有变化，记录变化
        if (guanjianjyfw !== that.originalCheguaGuanjianjyfw) {
          console.log("车挂罐检经营范围发生变化");
          console.log("原始值:", that.originalCheguaGuanjianjyfw);
          console.log("当前值:", guanjianjyfw);
          that.cheguaGuanjianjyfwChanged = true; // 设置变化标记
        }
        
        currentCheguaData.guantitiji = that.guantitiji;
        currentCheguaData.guanjianyxq = that.guanjianyxq;
        
        // 处理罐检图片URL
        let guanjianbgurl = "";
        if (that.guanjianbgurlArr.length > 0) {
          guanjianbgurl = that.guanjianbgurlArr.join(',');
        }
        currentCheguaData.guanjianbgurl = guanjianbgurl;
        
        // 处理舱室信息
        let cangshi = "";
        switch (that.cabinValue) {
          case "单舱": cangshi = "01"; break;
          case "双舱": cangshi = "02"; break;
          case "三舱": cangshi = "03"; break;
        }
        currentCheguaData.cangshi = cangshi;
        
        currentCheguaData.cangshilifang1 = that.cangshilifang1;
        currentCheguaData.cangshilifang2 = that.cangshilifang2;
        currentCheguaData.cangshilifang3 = that.cangshilifang3;
        currentCheguaData.beizhu = that.beizhu;
      }
      
      // 逐个比较字段
      const fieldsToCompare = Object.keys(currentCheguaData);
      for (const field of fieldsToCompare) {
        // 跳过xingshizhengzbfmurl字段
        if (field === 'xingshizhengzbfmurl') continue;
        
        const currentValue = currentCheguaData[field];
        const originalValue = that.originalCheguaData[field];
        
        // 处理数值类型
        if (typeof currentValue === 'number' || typeof originalValue === 'number') {
          // 将空字符串或null/undefined转为0进行比较
          const currVal = currentValue === "" || currentValue === null || currentValue === undefined ? 0 : Number(currentValue);
          const origVal = originalValue === "" || originalValue === null || originalValue === undefined ? 0 : Number(originalValue);
          
          if (currVal !== origVal) {
            console.log(`车挂字段 ${field} 发生变化: 原值=${originalValue}, 当前值=${currentValue}`);
            return true;
          }
        } 
        // 处理数组或对象类型
        else if (typeof currentValue === 'object' || typeof originalValue === 'object') {
          // 将null/undefined转为空字符串进行比较
          const currVal = currentValue === null || currentValue === undefined ? "" : JSON.stringify(currentValue);
          const origVal = originalValue === null || originalValue === undefined ? "" : JSON.stringify(originalValue);
          
          if (currVal !== origVal) {
            console.log(`车挂字段 ${field} 发生变化: 原值=${originalValue}, 当前值=${currentValue}`);
            return true;
          }
        }
        // 处理字符串类型
        else {
          // 将null/undefined转为空字符串进行比较
          const currVal = currentValue === null || currentValue === undefined ? "" : String(currentValue);
          const origVal = originalValue === null || originalValue === undefined ? "" : String(originalValue);
          
          if (currVal !== origVal) {
            console.log(`车挂字段 ${field} 发生变化: 原值=${originalValue}, 当前值=${currentValue}`);
            return true;
          }
        } 
      }
      
      return false;
    },
    
    // 更新车头数据
    updateChetou() {
      console.log('更新车头数据');
      const that = this;
      
      // 构建车头表单数据，根据vehicleUsage.typecode设置不同的字段
      var headFormData = {
        // 更新需要保留openid
        openid: localStorage['wx_openid'],
        chetouhao: that.chetouhao,
        sscd: that.sscd,
        vehicleUsage: that.vehicleUsage.typecode,
        xingshizhengzbfmurl: that.xsz_zb_fm_url, // 行驶证正页在所有模式下都需要
        id: that.chetouId // 添加ID字段
      };
      
      // 根据vehicleUsage.typecode添加不同的字段
      if (that.vehicleUsage.typecode === '2') {
        // 完整模式下的额外字段
        headFormData.xingshizhengyxq = that.xingshizhengyxq;
        headFormData.ctzl = that.ctzl;
        headFormData.zhengbeizhiliang = that.zhengbeizhiliang;
        headFormData.zongzhiliang = that.zongzhiliang;
        headFormData.chejiahao = that.chejiahao;
        headFormData.xingshizhenghdzzl = that.xingshizhenghdzzl;
        headFormData.xingshizhengzbzmurl = that.xsz_zb_zm_url;
        headFormData.xingshizhengfbzmurl = that.xsz_fb_zm_url;
        headFormData.xingshizhengfbfmurl = that.xsz_fb_fm_url;
      }

      // 如果是蒸洗+作业类型，添加道路运输证信息
      if (that.vehicleUsage.typecode == '2') {
          // 处理道路运输证经营范围
          var daoluyszjyfw = "";
          if (that.selectedData.length > 0) {
            for (var i = 0; i < that.selectedData.length; i++) {
              daoluyszjyfw += that.selectedData[i] + "|";
            }
            // 去掉最后一个分隔符
            if (daoluyszjyfw.length > 0) {
              daoluyszjyfw = daoluyszjyfw.substr(0, daoluyszjyfw.length - 1);
            }
          }

        // 添加道路运输证相关字段
        headFormData.daoluyszhao = that.daoluyszhao;
        headFormData.daoluyszjyfw = daoluyszjyfw;
        headFormData.daoluyszyxq = that.daoluyszyxq;
        headFormData.daoluyszzbzmurl = that.dlys_zm_url;
        headFormData.daoluyszdlzmurl = that.dcl_zm_url;
        headFormData.daoluyszdlfmurl = that.dcl_fm_url;
        headFormData.beizhu = that.beizhuHead;
      }
      
      // 静默更新，不显示确认弹窗
      console.log("车头数据有变化，静默更新中...");
      api.updateBeianChetou(JSON.stringify(headFormData)).then(function(res) {
            var resData = JSON.parse(res);
            if (resData.respCode == "0") {
          // 清掉首页车辆缓存，让回首页时重新拉最新行驶证有效期
          localStorage.removeItem('vehicleInfo');
          console.log("车头更新成功");
          
          // 检查返回的数据中是否包含bpmStatus
          if (resData.data && resData.data.bpmStatus) {
            that.chetouBpmStatus = resData.data.bpmStatus;
            
            if (that.vehicleUsage.typecode === '1') {
              // 精简模式，后端应自动设置bpmStatus为3
              console.log("精简模式车头更新，后端返回bpmStatus=", that.chetouBpmStatus);
              if (that.chetouBpmStatus == 3) {
                console.log("后端正确设置了精简模式车头的bpmStatus为3（已通过）");
              } else {
                console.log("警告：精简模式车头的bpmStatus不是预期的3，而是", that.chetouBpmStatus);
              }
            } else if (resData.data.bpmStatus == 1 && !that.isNewChetou) {
              // 完整模式，如果bpmStatus为1且不是新建车头，说明后端因为道路运输证经营范围变化将状态改为了1
              console.log("后端检测到车头道路运输证经营范围变化，bpmStatus被设置为1");
              that.chetouDaoluyszjyfwChanged = true;
            }
          }
          
          // 检查是否需要更新车挂
          if (that.cheguaDataChanged) {
            that.updateChegua();
            } else {
            // 车挂不需要更新，直接提交审核
            that.submitChetou();
          }
        } else {
          // 记录车头更新失败的消息
          console.log("车头更新失败:", resData.message);
          Toast.fail('车头信息更新失败: ' + resData.message);
          // 检查是否需要更新车挂
          if (that.cheguaDataChanged) {
            that.updateChegua();
          } else {
            // 车挂不需要更新，直接提交审核
            that.submitChetou();
          }
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('车头信息更新失败');
        // 检查是否需要更新车挂
        if (that.cheguaDataChanged) {
          that.updateChegua();
        } else {
          // 车挂不需要更新，直接提交审核
          that.submitChetou();
        }
      });
    },

    // 更新车挂数据
    updateChegua() {
      console.log('更新车挂数据');
      const that = this;

          // 处理道路运输证经营范围
          var trailerDaoluyszjyfw = "";
          if (that.trailer_selectedData.length > 0) {
            for (var i = 0; i < that.trailer_selectedData.length; i++) {
              trailerDaoluyszjyfw += that.trailer_selectedData[i] + "|";
            }
            // 去掉最后一个分隔符
            if (trailerDaoluyszjyfw.length > 0) {
              trailerDaoluyszjyfw = trailerDaoluyszjyfw.substr(0, trailerDaoluyszjyfw.length - 1);
            }
          }

          // 处理罐检经营范围
          var guanjianjyfw = "";
          if (that.gtSelectedData.length > 0) {
            for (var j = 0; j < that.gtSelectedData.length; j++) {
              guanjianjyfw += that.gtSelectedData[j] + "|";
            }
            // 去掉最后一个分隔符
            if (guanjianjyfw.length > 0) {
              guanjianjyfw = guanjianjyfw.substr(0, guanjianjyfw.length - 1);
            }
          }

          // 处理罐检图片URL
          var guanjianbgurl = "";
          var guanjianbgurlArr = that.guanjianbgurlArr;
          if (guanjianbgurlArr.length > 0) {
            for (var k = 0; k < guanjianbgurlArr.length; k++) {
              guanjianbgurl += guanjianbgurlArr[k] + ",";
            }
            // 去掉最后一个逗号
            if (guanjianbgurl.length > 0) {
              guanjianbgurl = guanjianbgurl.substr(0, guanjianbgurl.length - 1);
            }
          }

          // 处理舱室信息
          var cangshi = "";
          switch (that.cabinValue) {
            case "单舱":
              cangshi = "01";
              break;
            case "双舱":
              cangshi = "02";
              break;
            case "三舱":
              cangshi = "03";
              break;
          }

      // 获取车挂所属车队，若为空则使用车头的值（作为兜底方案）
      const trailerSscd = that.trailer_sscd || that.sscd;
      
      // 构建车挂表单数据，根据vehicleUsage.typecode设置不同的字段
      var trailerFormData = {
        // 更新需要保留openid
        openid: localStorage['wx_openid'],
            cheguahao: that.cheguahao,
        sscd: trailerSscd, // 使用处理后的值
        guanticaizhi: that.guanticaizhi, // 罐体材质在所有模式下都需要
        sfjzx: that.sfjzx, // 是否集装箱在所有模式下都需要
            vehicleUsage: that.vehicleUsage.typecode,
        xingshizhengzbfmurl: that.trailer_xsz_zb_fm_url, // 行驶证正页在所有模式下都需要
        id: that.cheguaId // 添加ID字段
      };
      
      // 根据vehicleUsage.typecode添加不同的字段
      if (that.vehicleUsage.typecode === '1') {
        // 精简模式下的特有字段
        trailerFormData.cssl = that.cssl; // 货仓数量仅在精简模式下需要
        
        // 精简模式下不需要舱室信息
        trailerFormData.beizhu = that.beizhu;
      } else if (that.vehicleUsage.typecode === '2') {
        // 完整模式下的额外字段
        trailerFormData.xingshizhengyxq = that.trailer_xingshizhengyxq;
        trailerFormData.zhengbeizhiliang = that.trailer_zhengbeizhiliang;
        trailerFormData.chejiahao = that.trailer_chejiahao;
        trailerFormData.xingshizhenghdzzl = that.trailer_xingshizhenghdzzl;
        trailerFormData.xingshizhengzbzmurl = that.trailer_xsz_zb_zm_url;
        trailerFormData.xingshizhengfbzmurl = that.trailer_xsz_fb_zm_url;
        trailerFormData.xingshizhengfbfmurl = that.trailer_xsz_fb_fm_url;
        
        // 道路运输证信息
        trailerFormData.daoluyszhao = that.trailer_daoluyszhao;
        trailerFormData.daoluyszjyfw = trailerDaoluyszjyfw;
        trailerFormData.daoluyszyxq = that.trailer_daoluyszyxq;
        trailerFormData.daoluyszzbzmurl = that.trailer_dlys_zm_url;
        trailerFormData.daoluyszdlzmurl = that.trailer_dcl_zm_url;
        trailerFormData.daoluyszdlfmurl = that.trailer_dcl_fm_url;
        
        // 罐体信息
        trailerFormData.guanjianjyfw = guanjianjyfw;
        trailerFormData.guantitiji = that.guantitiji;
        trailerFormData.guanjianyxq = that.guanjianyxq;
        trailerFormData.guanjianbgurl = guanjianbgurl;
        
        // 舱室信息
        trailerFormData.cangshi = cangshi;
        trailerFormData.cangshilifang1 = that.cangshilifang1;
        trailerFormData.cangshilifang2 = that.cangshilifang2;
        trailerFormData.cangshilifang3 = that.cangshilifang3;
        trailerFormData.cangshilifang4 = 0;
        
        trailerFormData.beizhu = that.beizhu;
      }

      // 检查车挂是否存在
      if (that.isCheguaExist && that.cheguaId) {
        console.log("车挂已存在，ID:", that.cheguaId);
        
        // 使用compareCheguaData方法检查数据是否有变化
        that.cheguaDataChanged = that.compareCheguaData();
        console.log("车挂数据变化状态:", that.cheguaDataChanged);
        
        // 如果数据有变化，调用更新接口
        if (that.cheguaDataChanged) {
          console.log("车挂数据有变化，调用更新接口");
          // 添加ID字段
          trailerFormData.id = that.cheguaId;
          // 确保无论哪种模式都添加隔仓数量
          trailerFormData.cssl = that.cssl;
          
          // 调用更新接口
          api.updateBeianChegua(JSON.stringify(trailerFormData)).then(function(res) {
            var resData = JSON.parse(res);
            if (resData.respCode == "0") {
              // 清掉首页车辆缓存，让回首页时重新拉最新行驶证有效期
              localStorage.removeItem('vehicleInfo');
              console.log("车挂更新成功");
              
              // 检查返回的数据中是否包含bpmStatus
              if (resData.data && resData.data.bpmStatus) {
                that.cheguaBpmStatus = resData.data.bpmStatus;
                
                if (that.vehicleUsage.typecode === '1') {
                  // 精简模式，后端应自动设置bpmStatus为3
                  console.log("精简模式车挂更新，后端返回bpmStatus=", that.cheguaBpmStatus);
                  if (that.cheguaBpmStatus == 3) {
                    console.log("后端正确设置了精简模式车挂的bpmStatus为3（已通过）");
                  } else {
                    console.log("警告：精简模式车挂的bpmStatus不是预期的3，而是", that.cheguaBpmStatus);
                  }
                } else if (resData.data.bpmStatus == 1 && !that.isNewChegua) {
                  // 完整模式，如果bpmStatus为1且不是新建车挂，说明后端因为道路运输证经营范围或罐检经营范围变化将状态改为了1
                  console.log("后端检测到车挂道路运输证经营范围或罐检经营范围变化，bpmStatus被设置为1");
                  
                  // 通过比较原始值和当前值，确定是哪个字段发生了变化
                  // 处理道路运输证经营范围
                  var trailerDaoluyszjyfw = "";
                  if (that.trailer_selectedData.length > 0) {
                    trailerDaoluyszjyfw = that.trailer_selectedData.join('|');
                  }
                  if (trailerDaoluyszjyfw !== that.originalCheguaDaoluyszjyfw) {
                    that.cheguaDaoluyszjyfwChanged = true;
                  }
                  
                  // 处理罐检经营范围
                  var guanjianjyfw = "";
                  if (that.gtSelectedData.length > 0) {
                    guanjianjyfw = that.gtSelectedData.join('|');
                  }
                  if (guanjianjyfw !== that.originalCheguaGuanjianjyfw) {
                    that.cheguaGuanjianjyfwChanged = true;
                  }
                }
              }
              
              // 继续提交审核
              that.submitChetou();
            } else {
              that.loadingBtn = false;
              console.log("车挂更新失败:", resData.message);
              Toast.fail('车挂信息更新失败: ' + resData.message);
              // 尽管更新失败，仍继续提交审核
              that.submitChetou();
            }
          }).catch(function(err) {
            console.log(err);
            that.loadingBtn = false;
            Toast.fail('车挂信息更新失败');
            // 尽管更新失败，仍继续提交审核
            that.submitChetou();
          });
        } else {
          console.log("车挂数据无变化，直接进入下一步");
          // 数据无变化，直接进入下一步
          that.submitChetou();
        }
      } else {
        // 车挂不存在，创建新车挂
        console.log("创建新车挂");
        
        api.beianChegua(JSON.stringify(trailerFormData)).then(function(res) {
          var resData = JSON.parse(res);
          if (resData.respCode == "0") {
            // 清掉首页车辆缓存，让回首页时重新拉最新行驶证有效期
            localStorage.removeItem('vehicleInfo');
            // 保存车挂ID，后面提交审核需要
            that.cheguaId = resData.data.id;
            
            // 设置车挂bpmStatus
            if (that.vehicleUsage.typecode === '1') {
              // 精简模式，后端应自动设置bpmStatus为3
              if (resData.data && resData.data.bpmStatus) {
                that.cheguaBpmStatus = resData.data.bpmStatus;
                console.log("精简模式新建车挂，后端返回bpmStatus=", that.cheguaBpmStatus);
                if (that.cheguaBpmStatus == 3) {
                  console.log("后端正确设置了精简模式车挂的bpmStatus为3（已通过）");
                } else {
                  console.log("警告：精简模式车挂的bpmStatus不是预期的3，而是", that.cheguaBpmStatus);
                }
              } else {
                that.cheguaBpmStatus = 3; // 默认设置为3
                console.log("精简模式新建车挂，默认设置bpmStatus=3");
              }
            } else {
              // 完整模式，新建的车挂bpmStatus为1（未提交）
              that.cheguaBpmStatus = 1;
              console.log("完整模式新建车挂，设置bpmStatus=1（未提交）");
            }
            
            // 标记为新建车挂
            that.isNewChegua = true;
            // 车挂保存成功后，提交审核
          that.submitChetou();
        } else {
            that.loadingBtn = false;
          Dialog.alert({
              message: resData.message,
          });
        }
      }).catch(function(err) {
        console.log(err);
        that.loadingBtn = false;
          Toast.fail('连接失败，请刷新页面');
      });
      }
    },

    // 提交车头审核
    submitChetou() {
      console.log('提交车头审核');
      const that = this;
      that.loadingBtn = false; // 关闭加载状态，避免长时间显示

      // 检查是否有车头ID
      if (!that.chetouId) {
        that.closeLoadingToast(); // 关闭加载提示

        // AI 对话危货新司机绑定流程完成（无法自动提交审核），打标
        that.markAiChatVehicleBoundIfNeeded();

        Dialog.alert({
          message: '车辆信息提交并绑定成功，但无法自动提交审核，请到车辆管理页面手动提交',
        }).then(() => {
          if (store.state.isFirstTime) {
            that.$router.push({
              name: 'vehicle',
              query: {
                bootFlag: 'finish'
              }
            });
          } else {
            that.$router.push({
              name: 'vehicle'
            });
          }
        });
        return;
      }

      // 输出更详细的日志
      console.log("车头状态: bpmStatus=", that.chetouBpmStatus, "数据变化=", that.chetouDataChanged);

      // 判断是否需要提交车头审核
      // 精简模式(vehicleUsage.typecode为1)不需要提交审核，后端会自动将bpmStatus设为3
      if (that.vehicleUsage.typecode === '1') {
        console.log("车头使用精简模式(vehicleUsage.typecode=1)，无需提交审核，后端会自动将bpmStatus设为3");
        // 直接进入车挂审核流程
        that.submitChegua();
        return;
      }
      
      // 以下情况需要提交审核:
      // 1. 新建车头(isNewChetou=true且bpmStatus=1)
      // 2. 车头道路运输证经营范围发生变化(chetouDaoluyszjyfwChanged=true)
      // 3. 更新后端返回bpmStatus=1(isNewChetou=false且bpmStatus=1)
      if (that.isNewChetou || that.chetouDaoluyszjyfwChanged || (that.chetouBpmStatus == 1 && !that.isNewChetou)) {
        // 确定提交审核的原因
        let reason = "";
        if (that.isNewChetou) {
          reason = "新建车头";
        } else if (that.chetouDaoluyszjyfwChanged) {
          reason = "道路运输证经营范围发生变化";
        } else {
          reason = "后端检测到需要重新提交审核";
        }
        console.log("需要提交车头审核，原因:", reason);
        // 构建提交审核的表单数据
        let formData = new FormData();
        formData.append("id", that.chetouId);

        // 提交车头审核
        api.submitBeianChetou(formData).then(function(res) {
          var resData = JSON.parse(res);
          if (resData.respCode == "0") {
            // 清掉首页车辆缓存，让回首页时重新拉最新行驶证有效期
            localStorage.removeItem('vehicleInfo');
            console.log("车头审核提交成功");
            // 车头审核提交成功，接着提交车挂审核
            that.submitChegua();
          } else {
            that.closeLoadingToast(); // 关闭加载提示

            // AI 对话危货新司机绑定流程完成（车头审核提交失败），打标
            that.markAiChatVehicleBoundIfNeeded();

            Dialog.alert({
              message: '车辆信息提交并绑定成功，但车头审核提交失败: ' + resData.message,
            }).then(() => {
              if (store.state.isFirstTime) {
                that.$router.push({
                  name: 'vehicle',
                  query: {
                    bootFlag: 'finish'
                  }
                });
              } else {
                that.$router.push({
                  name: 'vehicle'
                });
              }
            });
          }
        }).catch(function(err) {
          console.log(err);
          that.closeLoadingToast(); // 关闭加载提示

          // AI 对话危货新司机绑定流程完成（车头审核提交失败），打标
          that.markAiChatVehicleBoundIfNeeded();

          Dialog.alert({
            message: '车辆信息提交并绑定成功，但提交审核失败，请到车辆管理页面手动提交',
          }).then(() => {
            if (store.state.isFirstTime) {
              that.$router.push({
                name: 'vehicle',
                query: {
                  bootFlag: 'finish'
                }
              });
            } else {
              that.$router.push({
                name: 'vehicle'
              });
            }
          });
        });
      } else if (that.chetouDataChanged) {
        // 数据有变化，只进行修改不需要提交审核
        console.log("车头数据有变化，已更新数据，无需提交审核");
        
        // 直接进入车挂审核流程，不提交车头审核
        that.submitChegua();
      } else {
          // 车头已提交过审核且数据无变化，直接进入车挂审核流程
          console.log("车头已提交过审核且数据无变化，bpmStatus=", that.chetouBpmStatus);
        that.submitChegua();
      }
    },

    // 提交车挂审核
    submitChegua() {
      console.log('提交车挂审核');
      const that = this;

      // 检查是否有车挂ID
      if (!that.cheguaId) {
        that.closeLoadingToast(); // 关闭加载提示

        // AI 对话危货新司机绑定流程完成（无法自动提交车挂审核），打标
        that.markAiChatVehicleBoundIfNeeded();

        Dialog.alert({
          message: '车辆信息和车头审核提交成功，但无法自动提交车挂审核，请到车辆管理页面手动提交',
        }).then(() => {
          if (store.state.isFirstTime) {
            that.$router.push({
              name: 'vehicle',
              query: {
                bootFlag: 'finish'
              }
            });
          } else {
            that.$router.push({
              name: 'vehicle'
            });
          }
        });
        return;
      }

      // 输出更详细的日志
      console.log("车挂状态: bpmStatus=", that.cheguaBpmStatus, "数据变化=", that.cheguaDataChanged);

      // 判断是否需要提交车挂审核
      // 精简模式(vehicleUsage.typecode为1)不需要提交审核，后端会自动将bpmStatus设为3
      if (that.vehicleUsage.typecode === '1') {
        console.log("车挂使用精简模式(vehicleUsage.typecode=1)，无需提交审核，后端会自动将bpmStatus设为3");
        // 构建成功消息
        let successMsg = '车辆信息提交并绑定成功！';

        // AI 对话危货新司机绑定流程完成，打标
        that.markAiChatVehicleBoundIfNeeded();

        that.closeLoadingToast(); // 关闭加载提示
        Dialog.alert({
          message: successMsg,
        }).then(() => {
          if (store.state.isFirstTime) {
            that.$router.push({
              name: 'vehicle',
              query: {
                bootFlag: 'finish'
              }
            });
          } else {
            that.$router.push({
              name: 'vehicle'
            });
          }
        });
        return;
      }
      
      // 以下情况需要提交审核:
      // 1. 新建车挂(isNewChegua=true)
      // 2. 车挂道路运输证经营范围发生变化(cheguaDaoluyszjyfwChanged=true)
      // 3. 车挂罐检经营范围发生变化(cheguaGuanjianjyfwChanged=true)
      // 4. 更新后端返回bpmStatus=1(isNewChegua=false且bpmStatus=1)
      if (that.isNewChegua || that.cheguaDaoluyszjyfwChanged || that.cheguaGuanjianjyfwChanged || (that.cheguaBpmStatus == 1 && !that.isNewChegua)) {
        // 输出提交审核的原因
        if (that.isNewChegua) {
          console.log("提交车挂审核原因: 新建车挂");
        } else if (that.cheguaDaoluyszjyfwChanged) {
          console.log("提交车挂审核原因: 道路运输证经营范围发生变化");
        } else if (that.cheguaGuanjianjyfwChanged) {
          console.log("提交车挂审核原因: 罐检经营范围发生变化");
        } else {
          console.log("提交车挂审核原因: 后端检测到需要重新提交审核");
        }
        
        // 构建提交审核的表单数据
        let formData = new FormData();
        formData.append("id", that.cheguaId);

        // 提交车挂审核
        api.submitBeianChegua(formData).then(function(res) {
          var resData = JSON.parse(res);
          var resMessage = "";
          if (resData.respCode == "0") {
            // 清掉首页车辆缓存，让回首页时重新拉最新行驶证有效期
            localStorage.removeItem('vehicleInfo');
            resMessage = '车辆信息已提交并全部送审成功！';
          } else {
            resMessage = '车辆信息提交并绑定成功，车头审核已提交，但车挂审核提交失败: ' + resData.message;
          }

          // AI 对话危货新司机绑定流程完成，打标
          that.markAiChatVehicleBoundIfNeeded();

          that.closeLoadingToast(); // 关闭加载提示
          Dialog.alert({
            message: resMessage,
          }).then(() => {
            if (store.state.isFirstTime) {
              that.$router.push({
                name: 'vehicle',
                query: {
                  bootFlag: 'finish'
                }
              });
            } else {
              that.$router.push({
                name: 'vehicle'
              });
            }
          });
        }).catch(function(err) {
          console.log(err);
          that.closeLoadingToast(); // 关闭加载提示

          // AI 对话危货新司机绑定流程完成（车挂审核提交失败），打标
          that.markAiChatVehicleBoundIfNeeded();

          Dialog.alert({
            message: '车辆信息和车头审核提交成功，但车挂审核提交失败，请到车辆管理页面手动提交',
          }).then(() => {
            if (store.state.isFirstTime) {
              that.$router.push({
                name: 'vehicle',
                query: {
                  bootFlag: 'finish'
                }
              });
            } else {
              that.$router.push({
                name: 'vehicle'
              });
            }
          });
        });
      } else if (that.cheguaDataChanged) {
        // 车挂数据有变化，只需要更新不需要提交审核
        console.log("车挂数据有变化，已更新数据，无需提交审核");

        // 构建成功消息
        let successMsg = '车辆信息提交并绑定成功！';

        // 根据车头情况调整消息
        if (that.chetouBpmStatus == 1) {
          successMsg = '车辆信息提交并绑定成功，车头已送审！';
        }

        // AI 对话危货新司机绑定流程完成，打标
        that.markAiChatVehicleBoundIfNeeded();

        that.closeLoadingToast(); // 关闭加载提示
        Dialog.alert({
          message: successMsg,
        }).then(() => {
          if (store.state.isFirstTime) {
            that.$router.push({
              name: 'vehicle',
              query: {
                bootFlag: 'finish'
              }
            });
          } else {
            that.$router.push({
              name: 'vehicle'
            });
          }
        });
      } else {
        // 车挂已提交过审核且数据无变化，直接显示成功
        console.log("车挂已提交过审核且数据无变化，bpmStatus=", that.cheguaBpmStatus);

        // 构建成功消息
        let successMsg = '车辆信息提交并绑定成功！';

        // 根据车头情况调整消息
        if (that.chetouBpmStatus == 1) {
          successMsg = '车辆信息提交并绑定成功，车头已送审！';
        }

        // AI 对话危货新司机绑定流程完成，打标
        that.markAiChatVehicleBoundIfNeeded();

        that.closeLoadingToast(); // 关闭加载提示
        Dialog.alert({
          message: successMsg,
        }).then(() => {
          if (store.state.isFirstTime) {
            that.$router.push({
              name: 'vehicle',
              query: {
                bootFlag: 'finish'
              }
            });
          } else {
            that.$router.push({
              name: 'vehicle'
            });
          }
        });
      }
    },

    // 创建车头
    createChetou() {
      console.log('创建新车头');
      const that = this;
      
      // 构建车头表单数据，根据vehicleUsage.typecode设置不同的字段
      var headFormData = {
        // 新增不需要openid
        chetouhao: that.chetouhao,
        sscd: that.sscd,
        vehicleUsage: that.vehicleUsage.typecode,
        xingshizhengzbfmurl: that.xsz_zb_fm_url, // 行驶证正页在所有模式下都需要
      };
      
      // 根据vehicleUsage.typecode添加不同的字段
      if (that.vehicleUsage.typecode === '2') {
        // 完整模式下的额外字段
        headFormData.xingshizhengyxq = that.xingshizhengyxq;
        headFormData.ctzl = that.ctzl;
        headFormData.zhengbeizhiliang = that.zhengbeizhiliang;
        headFormData.zongzhiliang = that.zongzhiliang;
        headFormData.chejiahao = that.chejiahao;
        headFormData.xingshizhenghdzzl = that.xingshizhenghdzzl;
        headFormData.xingshizhengzbzmurl = that.xsz_zb_zm_url;
        headFormData.xingshizhengfbzmurl = that.xsz_fb_zm_url;
        headFormData.xingshizhengfbfmurl = that.xsz_fb_fm_url;
      }

      // 如果是蒸洗+作业类型，添加道路运输证信息
      if (that.vehicleUsage.typecode == '2') {
        // 处理道路运输证经营范围
        var daoluyszjyfw = "";
        if (that.selectedData.length > 0) {
          for (var i = 0; i < that.selectedData.length; i++) {
            daoluyszjyfw += that.selectedData[i] + "|";
          }
          // 去掉最后一个分隔符
          if (daoluyszjyfw.length > 0) {
            daoluyszjyfw = daoluyszjyfw.substr(0, daoluyszjyfw.length - 1);
          }
        }

        // 添加道路运输证相关字段
        headFormData.daoluyszhao = that.daoluyszhao;
        headFormData.daoluyszjyfw = daoluyszjyfw;
        headFormData.daoluyszyxq = that.daoluyszyxq;
        headFormData.daoluyszzbzmurl = that.dlys_zm_url;
        headFormData.daoluyszdlzmurl = that.dcl_zm_url;
        headFormData.daoluyszdlfmurl = that.dcl_fm_url;
        headFormData.beizhu = that.beizhuHead;
      }
      
      // 创建车头
      api.beianChetou(JSON.stringify(headFormData)).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          // 清掉首页车辆缓存，让回首页时重新拉最新行驶证有效期
          localStorage.removeItem('vehicleInfo');
          // 保存车头ID，后面提交审核需要
          that.chetouId = resData.data.id;
          // 设置车头bpmStatus
          if (that.vehicleUsage.typecode === '1') {
            // 精简模式，后端应自动设置bpmStatus为3
            if (resData.data && resData.data.bpmStatus) {
              that.chetouBpmStatus = resData.data.bpmStatus;
              console.log("精简模式新建车头，后端返回bpmStatus=", that.chetouBpmStatus);
              if (that.chetouBpmStatus == 3) {
                console.log("后端正确设置了精简模式车头的bpmStatus为3（已通过）");
              } else {
                console.log("警告：精简模式车头的bpmStatus不是预期的3，而是", that.chetouBpmStatus);
              }
            } else {
              that.chetouBpmStatus = 3; // 默认设置为3
              console.log("精简模式新建车头，默认设置bpmStatus=3");
            }
          } else {
            // 完整模式，新建的车头bpmStatus为1（未提交）
            that.chetouBpmStatus = 1;
            console.log("完整模式新建车头，设置bpmStatus=1（未提交）");
          }
          
          that.isChetouExist = true;
          // 标记为新建车头
          that.isNewChetou = true;
          
          console.log("车头创建成功，ID:", that.chetouId);
          
          // 判断下一步操作
          if (!that.isCheguaExist) {
            // 车挂也不存在，继续创建车挂
            that.createChegua();
          } else {
            // 车挂已存在，执行绑定
            that.bindVehicle();
          }
        } else {
          that.loadingBtn = false;
          that.closeLoadingToast(); // 关闭加载提示
          Dialog.alert({
            message: '创建车头失败: ' + resData.message,
          });
        }
      }).catch(function(err) {
        console.log(err);
        that.loadingBtn = false;
        that.closeLoadingToast(); // 关闭加载提示
        Toast.fail('创建车头失败，请重试');
      });
    },
    
    // 创建车挂
    createChegua() {
      console.log('创建新车挂');
      const that = this;
      
      // 处理道路运输证经营范围
      var trailerDaoluyszjyfw = "";
      if (that.trailer_selectedData.length > 0) {
        for (var i = 0; i < that.trailer_selectedData.length; i++) {
          trailerDaoluyszjyfw += that.trailer_selectedData[i] + "|";
        }
        // 去掉最后一个分隔符
        if (trailerDaoluyszjyfw.length > 0) {
          trailerDaoluyszjyfw = trailerDaoluyszjyfw.substr(0, trailerDaoluyszjyfw.length - 1);
        }
      }

      // 处理罐检经营范围
      var guanjianjyfw = "";
      if (that.gtSelectedData.length > 0) {
        for (var j = 0; j < that.gtSelectedData.length; j++) {
          guanjianjyfw += that.gtSelectedData[j] + "|";
        }
        // 去掉最后一个分隔符
        if (guanjianjyfw.length > 0) {
          guanjianjyfw = guanjianjyfw.substr(0, guanjianjyfw.length - 1);
        }
      }

      // 处理罐检图片URL
      var guanjianbgurl = "";
      var guanjianbgurlArr = that.guanjianbgurlArr;
      if (guanjianbgurlArr.length > 0) {
        for (var k = 0; k < guanjianbgurlArr.length; k++) {
          guanjianbgurl += guanjianbgurlArr[k] + ",";
        }
        // 去掉最后一个逗号
        if (guanjianbgurl.length > 0) {
          guanjianbgurl = guanjianbgurl.substr(0, guanjianbgurl.length - 1);
        }
      }

      // 处理舱室信息
      var cangshi = "";
      switch (that.cabinValue) {
        case "单舱":
          cangshi = "01";
          break;
        case "双舱":
          cangshi = "02";
          break;
        case "三舱":
          cangshi = "03";
          break;
      }

      // 获取车挂所属车队，若为空则使用车头的值（作为兜底方案）
      const trailerSscd = that.trailer_sscd || that.sscd;
      
      // 构建车挂表单数据，根据vehicleUsage.typecode设置不同的字段
      var trailerFormData = {
        // 新增不需要openid
        cheguahao: that.cheguahao,
        sscd: trailerSscd, // 使用处理后的值
        guanticaizhi: that.guanticaizhi, // 罐体材质在所有模式下都需要
        sfjzx: that.sfjzx, // 是否集装箱在所有模式下都需要
        vehicleUsage: that.vehicleUsage.typecode,
        xingshizhengzbfmurl: that.trailer_xsz_zb_fm_url, // 行驶证正页在所有模式下都需要
        cssl: that.cssl, // 现在隔仓数量在两种模式下都需要
      };
      
      // 根据vehicleUsage.typecode添加不同的字段
      if (that.vehicleUsage.typecode === '1') {
        // 精简模式下的特有字段
        trailerFormData.cssl = that.cssl; // 货仓数量仅在精简模式下需要
        
        // 精简模式下不需要舱室信息
        trailerFormData.beizhu = that.beizhu;
      } else if (that.vehicleUsage.typecode === '2') {
        // 完整模式下的额外字段
        trailerFormData.xingshizhengyxq = that.trailer_xingshizhengyxq;
        trailerFormData.zhengbeizhiliang = that.trailer_zhengbeizhiliang;
        trailerFormData.chejiahao = that.trailer_chejiahao;
        trailerFormData.xingshizhenghdzzl = that.trailer_xingshizhenghdzzl;
        trailerFormData.xingshizhengzbzmurl = that.trailer_xsz_zb_zm_url;
        trailerFormData.xingshizhengfbzmurl = that.trailer_xsz_fb_zm_url;
        trailerFormData.xingshizhengfbfmurl = that.trailer_xsz_fb_fm_url;
        
        // 道路运输证信息
        trailerFormData.daoluyszhao = that.trailer_daoluyszhao;
        trailerFormData.daoluyszjyfw = trailerDaoluyszjyfw;
        trailerFormData.daoluyszyxq = that.trailer_daoluyszyxq;
        trailerFormData.daoluyszzbzmurl = that.trailer_dlys_zm_url;
        trailerFormData.daoluyszdlzmurl = that.trailer_dcl_zm_url;
        trailerFormData.daoluyszdlfmurl = that.trailer_dcl_fm_url;
        
        // 罐体信息
        trailerFormData.guanjianjyfw = guanjianjyfw;
        trailerFormData.guantitiji = that.guantitiji;
        trailerFormData.guanjianyxq = that.guanjianyxq;
        trailerFormData.guanjianbgurl = guanjianbgurl;
        
        // 舱室信息
        trailerFormData.cangshi = cangshi;
        trailerFormData.cangshilifang1 = that.cangshilifang1;
        trailerFormData.cangshilifang2 = that.cangshilifang2;
        trailerFormData.cangshilifang3 = that.cangshilifang3;
        trailerFormData.cangshilifang4 = 0;
        
        trailerFormData.beizhu = that.beizhu;
      }
      
      // 创建车挂
      api.beianChegua(JSON.stringify(trailerFormData)).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          // 清掉首页车辆缓存，让回首页时重新拉最新行驶证有效期
          localStorage.removeItem('vehicleInfo');
          // 保存车挂ID，后面提交审核需要
          that.cheguaId = resData.data.id;
          // 新建的车挂bpmStatus为1（未提交）
          that.cheguaBpmStatus = 1;
          that.isCheguaExist = true;
          
          console.log("车挂创建成功，ID:", that.cheguaId);
          
          // 判断下一步操作
          if (!that.isChetouExist) {
            // 车头也不存在，继续创建车头
            that.createChetou();
          } else {
            // 车头已存在，执行绑定
            that.bindVehicle();
          }
        } else {
          that.loadingBtn = false;
          that.closeLoadingToast(); // 关闭加载提示
          Dialog.alert({
            message: '创建车挂失败: ' + resData.message,
          });
        }
      }).catch(function(err) {
        console.log(err);
        that.loadingBtn = false;
        that.closeLoadingToast(); // 关闭加载提示
        Toast.fail('创建车挂失败，请重试');
      });
    },

    // 车头识别/手动输入后统一处理函数
    async handleChetouAfterRecognize(chetouhao) {
      if (!chetouhao) return;
      const that = this;
      const weburl = that.GLOBAL.weburl;
      const resData = await api.searchChetou(chetouhao);
      const res = typeof resData === 'string' ? JSON.parse(resData) : resData;
      if (res.respCode === '0' && res.data && res.data.length > 0) {
        const vehicleData = res.data[0];
        that.isChetouExist = true;
        that.chetouId = vehicleData.id;
        that.chetouBpmStatus = vehicleData.bpmStatus || 1;
        that.originalChetouData = JSON.parse(JSON.stringify(vehicleData));
        that.chetouhao = vehicleData.chetouhao || that.chetouhao;
        that.sscd = vehicleData.sscd || that.sscd;
        that.chejiahao = vehicleData.chejiahao || that.chejiahao;
        that.ctzl = vehicleData.ctzl || that.ctzl;
        that.zhengbeizhiliang = vehicleData.zhengbeizhiliang || that.zhengbeizhiliang;
        that.zongzhiliang = vehicleData.zongzhiliang || that.zongzhiliang;
        that.xingshizhenghdzzl = vehicleData.xingshizhenghdzzl || that.xingshizhenghdzzl;
        that.daoluyszyxq = vehicleData.daoluyszyxq || that.daoluyszyxq;
        that.xingshizhengyxq = vehicleData.xingshizhengyxq || that.xingshizhengyxq;
        that.beizhuHead = vehicleData.beizhu || that.beizhuHead;
        if (vehicleData.daoluyszjyfw) {
          that.daoluyszjyfw = vehicleData.daoluyszjyfw;
          const rangeArray = vehicleData.daoluyszjyfw.split('|');
          that.selectedData = rangeArray;
          that.pzArray = rangeArray;
        }
        if (vehicleData.vehicleUsage) {
          that.vehicleUsage = { typecode: vehicleData.vehicleUsage };
          if (vehicleData.vehicleUsage === '2') {
            that.useEditable = false;
          }
        }
        if (vehicleData.xingshizhengzbzmurl) {
          that.xsz_zb_zm_url = vehicleData.xingshizhengzbzmurl;
          that.xsz_zb_zm_image = [{ url: weburl + '/' + vehicleData.xingshizhengzbzmurl.split(',')[0] }];
        }
        if (vehicleData.xingshizhengfbzmurl) {
          that.xsz_fb_zm_url = vehicleData.xingshizhengfbzmurl;
          that.xsz_fb_zm_image = [{ url: weburl + '/' + vehicleData.xingshizhengfbzmurl }];
        }
        if (vehicleData.xingshizhengfbfmurl) {
          that.xsz_fb_fm_url = vehicleData.xingshizhengfbfmurl;
          that.xsz_fb_fm_image = [{ url: weburl + '/' + vehicleData.xingshizhengfbfmurl }];
        }
        if (vehicleData.daoluyszzbzmurl) {
          that.dlys_zm_url = vehicleData.daoluyszzbzmurl;
          that.dlys_zm_image = [{ url: weburl + '/' + vehicleData.daoluyszzbzmurl }];
        }
        if (vehicleData.daoluyszdlzmurl) {
          that.dcl_zm_url = vehicleData.daoluyszdlzmurl;
          that.dcl_zm_image = [{ url: weburl + '/' + vehicleData.daoluyszdlzmurl }];
        }
        if (vehicleData.daoluyszdlfmurl) {
          that.dcl_fm_url = vehicleData.daoluyszdlfmurl;
          that.dcl_fm_image = [{ url: weburl + '/' + vehicleData.daoluyszdlfmurl }];
        }
        this.$driverObj.destroy();
        const currentStep = this.$driverObj.getActiveStep();
        Dialog.alert({
              message:"系统已检测到该车头数据，后续信息已自动拉取，请进一步核实是否需要更新！",
            }).then(() => {
               // this.$driverObj.drive(currentStep);
            });     
        } else {
        that.isChetouExist = false;
        Toast('系统未检测到该车头信息，提交信息后将创建新车头');
      }
    },

    // 车挂识别/手动输入后统一处理函数
    async handleCheguaAfterRecognize(cheguahao) {
      if (!cheguahao) return;
      const that = this;
      const weburl = that.GLOBAL.weburl;
      const resData = await api.searchChegua(cheguahao);
      const res = typeof resData === 'string' ? JSON.parse(resData) : resData;
      if (res.respCode === '0' && res.data && res.data.length > 0) {
        const cheguaId = res.data[0].id;
        that.isCheguaExist = true;
        that.cheguaId = cheguaId;
        // 获取详细信息
        const detailResponse = await api.getCheguaBeianDetail(cheguaId);
        const detailData = typeof detailResponse === 'string' ? JSON.parse(detailResponse) : detailResponse;
        if (detailData && detailData.respCode === '0' && detailData.data) {
          const vehicleData = detailData.data;
          that.cheguaBpmStatus = vehicleData.bpmStatus || 1;
         
          that.originalCheguaData = JSON.parse(JSON.stringify(vehicleData));
          that.cheguahao = vehicleData.cheguahao || that.cheguahao;
          that.trailer_sscd = vehicleData.sscd || that.trailer_sscd;
          that.trailer_chejiahao = vehicleData.chejiahao || that.trailer_chejiahao;
          that.trailer_zhengbeizhiliang = vehicleData.zhengbeizhiliang || that.trailer_zhengbeizhiliang;
          that.trailer_xingshizhenghdzzl = vehicleData.xingshizhenghdzzl || that.trailer_xingshizhenghdzzl;
          that.trailer_daoluyszyxq = vehicleData.daoluyszyxq || that.trailer_daoluyszyxq;
          that.trailer_xingshizhengyxq = vehicleData.xingshizhengyxq || that.trailer_xingshizhengyxq;
          that.sfjzx = vehicleData.sfjzx || that.sfjzx;
          that.cssl = vehicleData.cssl || that.cssl;
          that.beizhu = vehicleData.beizhu || that.beizhu;
          if (vehicleData.daoluyszjyfw) {
            that.trailer_daoluyszjyfw = vehicleData.daoluyszjyfw;
            const rangeArray = vehicleData.daoluyszjyfw.split('|');
            that.trailer_selectedData = rangeArray;
            that.trailer_pzArray = rangeArray;
          }
          if (vehicleData.guantitiji) {
            that.guantitiji = vehicleData.guantitiji;
          }
          if (vehicleData.guanticaizhi) {
            that.guanticaizhi = vehicleData.guanticaizhi;
          }
          if (vehicleData.guanjianyxq) {
            that.guanjianyxq = vehicleData.guanjianyxq;
          }
          if (vehicleData.guanjianjyfw) {
            const gtRangeArray = vehicleData.guanjianjyfw.split('|');
            that.gtSelectedData = gtRangeArray;
            that.gtPzArray = gtRangeArray;
          }
          if (vehicleData.cangshi) {
            switch (vehicleData.cangshi) {
              case '01': that.cabinValue = '单舱'; break;
              case '02': that.cabinValue = '双舱'; break;
              case '03': that.cabinValue = '三舱'; break;
            }
            that.cangshilifang1 = vehicleData.cangshilifang1 || that.cangshilifang1;
            that.cangshilifang2 = vehicleData.cangshilifang2 || that.cangshilifang2;
            that.cangshilifang3 = vehicleData.cangshilifang3 || that.cangshilifang3;
          }
          if (vehicleData.xingshizhengzbzmurl) {
            that.trailer_xsz_zb_zm_url = vehicleData.xingshizhengzbzmurl;
            that.trailer_xsz_zb_zm_image = [{ url: weburl + '/' + vehicleData.xingshizhengzbzmurl.split(',')[0] }];
          }
          if (vehicleData.xingshizhengzbfmurl) {
            that.trailer_xsz_zb_fm_url = vehicleData.xingshizhengzbfmurl;
            that.trailer_xsz_zb_fm_image = [{ url: weburl + '/' + vehicleData.xingshizhengzbfmurl }];
          }
          if (vehicleData.xingshizhengfbzmurl) {
            that.trailer_xsz_fb_zm_url = vehicleData.xingshizhengfbzmurl;
            that.trailer_xsz_fb_zm_image = [{ url: weburl + '/' + vehicleData.xingshizhengfbzmurl }];
          }
          if (vehicleData.xingshizhengfbfmurl) {
            that.trailer_xsz_fb_fm_url = vehicleData.xingshizhengfbfmurl;
            that.trailer_xsz_fb_fm_image = [{ url: weburl + '/' + vehicleData.xingshizhengfbfmurl }];
          }
          if (vehicleData.daoluyszzbzmurl) {
            that.trailer_dlys_zm_url = vehicleData.daoluyszzbzmurl;
            that.trailer_dlys_zm_image = [{ url: weburl + '/' + vehicleData.daoluyszzbzmurl }];
          }
          if (vehicleData.daoluyszdlzmurl) {
            that.trailer_dcl_zm_url = vehicleData.daoluyszdlzmurl;
            that.trailer_dcl_zm_image = [{ url: weburl + '/' + vehicleData.daoluyszdlzmurl }];
          }
          if (vehicleData.daoluyszdlfmurl) {
            that.trailer_dcl_fm_url = vehicleData.daoluyszdlfmurl;
            that.trailer_dcl_fm_image = [{ url: weburl + '/' + vehicleData.daoluyszdlfmurl }];
          }
          if (vehicleData.guanjianbgurl) {
            let guanjianbgImageArr = [];
            let guanjianbgurlArr = [];
            const imageDataArr = vehicleData.guanjianbgurl.split(',');
            for (let i = 0; i < imageDataArr.length; i++) {
              if (imageDataArr[i]) {
                guanjianbgImageArr.push({ url: weburl + '/' + imageDataArr[i] });
                guanjianbgurlArr.push(imageDataArr[i]);
              }
            }
            that.guanjianbgimage = guanjianbgImageArr;
            that.guanjianbgImageArr = guanjianbgImageArr;
            that.guanjianbgurlArr = guanjianbgurlArr;
          }
          Dialog.alert({
              message:"系统已检测到该车挂数据，后续信息已自动拉取，请进一步核实是否需要更新！",
            });
        }
      } else {
        that.isCheguaExist = false;
        Toast('系统未检测到该车挂信息，提交信息后将创建新车挂');
      }
    },

    // 修改uploadXszZbFm函数，调用封装函数
    uploadXszZbFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const type = 'xsz_zb_fm';
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadXsz(type, formData).then(async function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.xsz_zb_fm_url = imageData.xingshizhengzbfmurl ? imageData.xingshizhengzbfmurl : "";
          that.xsz_zb_fm_image = imageData.xingshizhengzbfmurl ? [{ url: weburl + '/' + imageData.xingshizhengzbfmurl }] : [];
          if (imageData.chetouhao) {
            that.chetouhao = imageData.chetouhao;
            await that.handleChetouAfterRecognize(imageData.chetouhao);
            that.$nextTick(() => {
              that.$store.state.isFirstTime && (that.hasFilled = true)
            });
          }
          if (imageData.bpmStatus === "3") {
            var detail = imageData;
            that.mergeinfo(detail);
          }
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },

    // 修改uploadTrailerXszZbFm函数，调用封装函数
    uploadTrailerXszZbFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      const that = this;
      const type = 'xsz_zb_fm';
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadCheguaXsz(type, formData).then(async function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.trailer_xsz_zb_fm_url = imageData.xingshizhengzbfmurl ? imageData.xingshizhengzbfmurl : "";
          that.trailer_xsz_zb_fm_image = imageData.xingshizhengzbfmurl ? [{ url: weburl + '/' + imageData.xingshizhengzbfmurl }] : [];
          if (imageData.cheguahao) {
            that.cheguahao = imageData.cheguahao;
            that.trailer_sscd = imageData.sscd || that.trailer_sscd;
            await that.handleCheguaAfterRecognize(imageData.cheguahao);
          }
          if (imageData.bpmStatus === "3") {
            var detail = imageData;
            that.mergeTrailerInfo(detail);
          }
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    // 车头号输入框 blur 事件
    onChetouBlur() {
      if (this.chetouhao && this.chetouhao.length >= 4 && this.chetouEditable) {
        this.handleChetouAfterRecognize(this.chetouhao);
      }
    },
    // 车挂号输入框 blur 事件
    onCheguaBlur() {
      if (this.cheguahao && this.cheguahao.length >= 5 && this.cheguaEditable) {
        this.handleCheguaAfterRecognize(this.cheguahao);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.content {
  margin-top: 1rem;
  margin-bottom: 3.75rem;
  padding-bottom: env(safe-area-inset-bottom);
}

// 回到顶部按钮样式
.back-to-top {
  position: fixed;
  right: 20px;
  bottom: 160px;
  width: 40px;
  height: 40px;
  background-color: rgba(64, 128, 255, 0.9);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 99;
  animation: fadeIn 0.3s;
  cursor: pointer;

  &:active {
    background-color: rgba(64, 128, 255, 0.7);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

// 删除原有步骤条样式
.steps-container {
  margin: 0.5rem 1rem 1.5rem;
}

// 添加自定义步骤条样式
.custom-steps-container {
  margin: 1rem 1rem 2rem;
}

.custom-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0;
}

.custom-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  z-index: 1;

  .step-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #ebedf0;
    color: #969799;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.6rem;
    font-weight: bold;
    margin-bottom: 0.8rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .step-title {
    font-size: 18px; /* 保留步骤导航的字体大小 */
    color: #969799;
    font-weight: bold;
  }

  &.active {
    .step-icon {
      background-color: #4080ff;
      color: white;
    }

    .step-title {
      color: #323233;
    }
  }

  &.completed {
    .step-icon {
      background-color: #07c160;
      color: white;
    }
  }
}

.step-line {
  flex: 1;
  height: 4px;
  background-color: #ebedf0;
  margin: 0 10px;
  margin-bottom: 1.8rem;

  &.active {
    background-color: #07c160;
  }
}

.form-card {
  margin-bottom: 1rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.section-title {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background: #f7f8fa;
  border-bottom: 1px solid #ebedf0;

  span {
    margin-left: 0.5rem;
    font-size: 15px;
    font-weight: 500;
    color: #323233;
  }
}

.upload-box {
  padding: 0.5rem 0;

  .upload-title {
    padding: 0.5rem 1rem;
    font-size: 15px;
    font-weight: normal;
    position: relative;

    .image-show {
      margin-left: 0.5rem;
      color: #4080ff;
      font-size: 15px;
    }
  }

  .upload-container {
    margin: 0 1rem 1rem;
  }
}

.info-box {
  padding: 0.5rem 0;
}

.field-label {
  font-weight: normal;
  font-size: 15px;
  white-space: nowrap;
  flex-shrink: 0;
}

.unit {
  padding-left: 0.2rem;
  color: #969799;
  font-size: 15px;
}

.btn-container {
  margin: 1.5rem 1rem;
}


.red-required {
  position: relative;
  padding-left: 0.75rem;

  &::before {
    position: absolute;
    left: 0;
    color: #ee0a24;
    font-size: 15px;
    content: '*';
  }
}

// 底部按钮组
.prev-btn {
  margin-right: 0.5rem;
  flex: 1;
}

.submit-btn {
  flex: 2;
}

.btn-container {
  display: flex;
  margin: 1.5rem 1rem;
}

/* 第一步上一步按钮样式 */
.prev-btn {
  margin-right: 10px;
  flex: 1;
}

/* 基本信息右侧对齐 */
:deep(.van-field__control) {
  text-align: right;
  font-size: 15px;
}

:deep(.van-field--center) .van-field__control {
  margin: 0;
}

/* 移除箭头图标 */
:deep(.no-arrow .van-cell__right-icon) {
  display: none;
}

/* 用途提示信息样式 */
.usage-tip {
  margin: 0 1rem 1rem;
  color: #666;
  font-size: 15px;
  line-height: 1.5;

  .back-link {
    color: #4080ff;
    font-weight: bold;
    cursor: pointer;
  }
}

/* 按钮文本样式 */
:deep(.van-button__text) {
  font-size: 15px;
}

/* Radio文本样式 */
:deep(.van-radio__label) {
  font-size: 15px;
}

/* 表单错误提示文本样式 */
:deep(.van-field__error-message) {
  font-size: 15px;
}

/* Toast提示文本样式 */
:deep(.van-toast) {
  font-size: 15px;
}

/* 弹窗文本样式 */
:deep(.van-dialog__message) {
  font-size: 15px;
}

/* 输入框标签样式 */
:deep(.van-field__label) {
  font-size: 15px;
}

/* 备注文本域样式 */
textarea {
  font-size: 15px !important;
}

/* 提示文本样式 */
.usage-tip {
  font-size: 15px;
}

/* 导航栏样式 */
:deep(.van-nav-bar__title) {
  font-size: 16px;
}

.readonly-notice {
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  background: #f7f8fa;
  border-radius: 0.5rem;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;

  .van-notice-bar {
    padding: 0;
  }
}

.readonly-images {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.5rem;

  .van-image {
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
}

</style>
